import React, { useState, useEffect } from "react";
import { CaretLeft } from "phosphor-react";
import Select from "react-select";
import "./popup.css";
import swal from "sweetalert";
import { AES, enc } from "crypto-js";
import { BASE_URL } from "../CommonApi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parseISO, addDays, endOfMonth, addMonths, format } from "date-fns";
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Alert from "@mui/material/Alert";
import { Editor } from "@tinymce/tinymce-react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function InvoiceUpdate(props) {
  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);
  const jwtToken = localStorage.getItem("jwtToken");

  // const [alternateUnitValue, setAlternateUnitValue] = useState(""); // Default value, replace with API value
  // const [calculatedAltUnitValue, setCalculatedAltUnitValue] = useState("");
  // const [alternateUnit, setAlternateUnit] = useState(""); // Default unit, replace with API value

  // const calculateAlternateUnitValue = (quantity) => {
  //   return quantity * alternateUnitValue; // Assuming 500 is the base value for alternate unit
  // };

  const [row, setRow] = useState([
    {
      itemDetails: "",
      itemCode:"",
      hsnSac: "",
      per:"1",
      quantity: "1.0",
      rate: "0.0",
      discount: "0.0",
      discountType: "₹",
      tax: "",
      alternateUnit: "", // Add this
      alternateUnitValue: "0.0", // Add this
      calculatedAltUnitValue: "0.0", // Add this
      singleAltUnitValue: "0.0",
      hasAlternateUnit: "",
    },
  ]);

  const handleAdd = () => {
    setUserDetails([
      ...userDetails,
      {
        itemDetails: "",
        itemCode:"",
        hsnSac: "",
        size: "",
        per:"1",
        quantity: "1.0",
        rate: "0.0",
        discount: "0.0",
        discountType: "₹",
        tax: "0",
        alternateUnit: "", // Add this
        alternateUnitValue: "0.0", // Add this
        calculatedAltUnitValue: "0.0", // Add this
        singleAltUnitValue: "0.0",
        hasAlternateUnit: "",
      },
    ]);
  };

  const [manualCheck, setManualCheck] = useState("No");
  const [bussinessRegistered, setBussinessRegistered] = useState("");
  const [userState, setUserState] = useState([]);
  const [customerState, setCustomerState] = useState("");
  const [discountAmountTds, setDiscountAmountTds] = useState(0.0);
  const [discountAmountTcs, setDiscountAmountTcs] = useState(0.0);
  const [discountCheck, setDiscountCheck] = useState("");
  const [netRateCheck, setNetRateCheck] = useState("");
  const [batchIdCheck, setBatchIdCheck] = useState("");
  const [sizeCheck, setSizeCheck] = useState("");
  const [hsnCheck, setHsnCheck] = useState("");
  const [quantityCheck,setQuantityCheck] = useState("");
  const [packCheck, setPackCheck] = useState("");
  const [disAllValue, setDisAllValue] = useState("");
  const [discountType, setDiscountType] = useState("₹");
  const [disValue, setDisValue] = useState("");
  const [selectedTaxType, setSelectedTaxType] = useState("");
  const [showing1, setShowing1] = useState(false);
  const [showing2, setShowing2] = useState(false);
  const [selectedTcsOption, setSelectedTcsOption] = useState(null);
  const [selectedTdsOption, setSelectedTdsOption] = useState(null);
  const [tType, setTType] = useState("");
  const [fetchedTdsOption, setFetchedTdsOption] = useState("");
  const [fetchedTcsOption, setFetchedTcsOption] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [content, setContent] = useState(""); // State to manage editor content

  const tcs = [
    { value: "0 GST [0%]", label: "0 GST [0%]",discount:0 },
    { value: "5 GST [5%]", label: "5 GST [5%]", discount: 5 },
    { value: "12 GST [12%]", label: "12 GST [12%]", discount: 12 },
    { value: "18 GST [18%]", label: "18 GST [18%]", discount: 18 },
    { value: "28 GST [28%]", label: "28 GST [28%]", discount: 28 },
  ];

  const tds = [
    {
      value: "Commission or Brokerag 5%",
      label: "Commission or Brokerag 5%",
      discount: 5,
    },
    {
      value: "Commission or Brokerag (Reduced) 3.75%",
      label: "Commission or Brokerag (Reduced) 3.75%",
      discount: 3.75,
    },
    { value: "Divident 10%", label: "Divident 10%", discount: 10 },
    {
      value: "Divident (Reduced) 7.5%",
      label: "Divident (Reduced) 7.5%",
      discount: 7.5,
    },
    {
      value: "Other Interest then securities 10%",
      label: "Other Interest then securities 10%",
      discount: 10,
    },
    {
      value: "Other Interest then securities (Reduced) 7.5%",
      label: "Other Interest then securities (Reduced) 7.5%",
      discount: 7.5,
    },
    {
      value: "Payment of Contractors Others 2%",
      label: "Payment of Contractors Others 2%",
      discount: 2,
    },
    {
      value: "Payment of Contractors Others (Reduced) 1.5%",
      label: "Payment of Contractors Others (Reduced) 1.5%",
      discount: 1.5,
    },
    {
      value: "Payment of Contractors Others HUD/Indiv 1%",
      label: "Payment of Contractors Others HUD/Indiv 1%",
      discount: 1,
    },
    {
      value: "Payment of Contractors Others HUD/Indiv (Reduced) 0.75%",
      label: "Payment of Contractors Others HUD/Indiv (Reduced) 0.75%",
      discount: 0.75,
    },
    {
      value: "Professional Fees 10%",
      label: "Professional Fees 10%",
      discount: 10,
    },
    {
      value: "Rent on land or furniture etc 10%",
      label: "Rent on land or furniture etc 10%",
      discount: 10,
    },
  ];

  const handleTdsOptionChange = (selectedOption) => {
    setSelectedTdsOption(selectedOption);
    setDiscountAmountTds(parseFloat(selectedOption.discount));
    const subtotal = calculateSubTotal();
    if (selectedOption && selectedOption.discount) {
      const discountedTotal = applyDiscount(subtotal, selectedOption.discount);
    }
  };

  const handleTcsOptionChange = (selectedOption) => {
    setSelectedTcsOption(selectedOption);
    setDiscountAmountTcs(parseFloat(selectedOption.discount));
    const subtotal = calculateSubTotal();
    if (selectedOption && selectedOption.discount) {
      const discountedTotal = applyDiscountTcs(
        subtotal,
        selectedOption.discount
      );
    }
  };

  const userId = localStorage.getItem("userId");
  const apiUrl = BASE_URL + `/fetchUserProfile`;
  const fetchData = () => {
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId, userId: userId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const userState = data.responseMessage;
          setUserState(userState);
        } else {
          console.error("Error fetching portfolio data");
        }
      })
      .catch((error) => {
        console.error("Error fetching portfolio data:", error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [currentDate, setCurrentDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  function handleUserDetails(e, rowId) {
    const { name, value } = e.target;
    const updatedUserDetails = userDetails.map((data) =>
      data.id === rowId ? { ...data, [name]: value } : data
    );
    setUserDetails(updatedUserDetails);
  }

  const handleDeleteRow = (i) => {
    const userConfirmed = window.confirm(
      "Are you sure you want to delete this row?"
    );
    if (userConfirmed) {
      const updatedRow = [...userDetails];
      updatedRow.splice(i, 1);
      setUserDetails(updatedRow);
      updateTotal(updatedRow);
    } else {
      console.log("Row deletion canceled.");
    }
  };

  const handleCancleClick = () => {
    const confirmCancel = window.confirm("Are you sure Leave this page?");
    if (confirmCancel) {
      // Code to handle cancellation
      props.handleCancel();
    } else {
      // Code to handle cancellation not confirmed
      console.log("Cancellation not confirmed");
    }
  };

  const customerNameOptions = [
    { value: "Ratikant Patil", label: "Ratikant Patil" },
    { value: "Anikent Rane", label: "Aniket Rane" },
    { value: "Samarth", label: "Samarth" },
  ];

  const [show1, setShow1] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  const openPopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const [showInvoice, setShowInvoice] = useState(false);

  const openInvoice = () => {
    setShowInvoice(true);
  };

  const closeInvoice = () => {
    setShowInvoice(false);
  };

  const [selectedTerms, setSelectedTerms] = useState("");
  const [dueDate, setDueDate] = useState(null);
  const [dueDateChangedManually, setDueDateChangedManually] = useState(false);

  const handleDiscountChange = (e, i) => {
    const { name, value } = e.target;
    const newValues =
      name === "discount" ? { discount: value } : { discountType: value };
    const newRow = [...row];
    newRow[i] = { ...newRow[i], ...newValues };
    setRow(newRow);
    updateTotal(newRow);
  };

  const handleQuantityChange = (e, i) => {
    const newQuantity = e.target.value;
    const newRow = [...row];
    newRow[i] = { ...newRow[i], quantity: newQuantity };
    setRow(newRow);
    updateTotal(row);
  };

  const handleRateChange = (e, i) => {
    const newRate = e.target.value;
    const newRow = [...row];
    newRow[i] = { ...newRow[i], rate: newRate };
    setRow(newRow);
    updateTotal(row);
  };

  const updateTotal = (rowData) => {
    let calculatedTotal = 0;
    rowData.forEach((data) => {
      const amount = calculateAmount(data);
      calculatedTotal += parseFloat(amount);
    });
    setTotal(calculatedTotal.toFixed(2));
  };
  const [total, setTotal] = useState(0.0);
  const calculateAmount = (data, tax) => {
    const { quantity, rate, discount, discountType } = data;
    let amount = quantity * rate;

    if (discount) {
      amount -= discountType === "%" ? (amount * discount) / 100 : discount;
    }

    return amount;
  };

  const calculateTAX = (data) => {
    const { tax } = data;
    let totalTAX = 0;
    if (tax > 0) {
      const amount = calculateAmount(data);
      const increasedTaxAmount = (parseFloat(amount) * tax) / 100;
      totalTAX = increasedTaxAmount;
    }
    return totalTAX.toFixed(2);
  };

  const [selectedTaxRate, setSelectedTaxRate] = useState(0);

  const calculateTaxAmount = (amount, taxRate) => {
    if (taxRate > 0) {
      let taxIncrease = 0;

      // Set tax increase based on tax rate
      switch (taxRate) {
        case 0.05:
          taxIncrease = 0.5;
          break;
        case 0.12:
          taxIncrease = 1.0;
          break;
        case 0.18:
          taxIncrease = 1.5;
          break;
        case 0.28:
          taxIncrease = 2.0;
          break;
        default:
          break;
      }

      return amount * (taxRate + taxIncrease);
    }
    return 0;
  };

  const calculateSubTotal = () => {
    let subTotal = 0;
    userDetails.forEach((data) => {
      const amount = calculateAmount(data);
      subTotal += parseFloat(amount);
    });
    return subTotal.toFixed(2);
  };

  const [adjustmentValue, setAdjustmentValue] = useState(""); // Step 1: State for adjustment value
  const [oppositeValue, setOppositeValue] = useState(""); // State for opposite value
  const [adjustment, setAdjustment] = useState("");

  useEffect(() => {
    const parsedValue = parseFloat(adjustmentValue);
    if (!isNaN(parsedValue)) {
      const opposite = parsedValue * 1;
      setOppositeValue(opposite.toFixed(2));
    } else {
      setOppositeValue("");
    }
  }, [adjustmentValue]);

  useEffect(() => {
    fetch(BASE_URL + `/fetchGst`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          const Data = data.responseMessage[0].businessRegistered;
        } else {
          console.error("Failed to fetch Customer Name:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching Customer Name:", error);
      });
  }, []);

  const calculateTotal = () => {
    const subTotal = parseFloat(calculateSubTotal());
    const igst = parseFloat(calculateIGST());
    const adjustment = parseFloat(adjustmentValue || formData.adjustment) || 0;
    const totalDis = parseFloat(disValue || formData.totalDiscount) || 0;
    const total1 = subTotal + igst + adjustment - totalDis;
    const total = total1 + discountAmountTcs;
    return total.toFixed(2);
  };

  const [oldQuantities, setOldQuantities] = useState([]);
  const [formData, setFormData] = useState([]);
  const [fetchedSalesPerson, setFetchedSalesPerson] = useState("");
  const [formDataCustomer, setFormDataCustomer] = useState({
    uniqueId: decryptedUniqueId,
    customerType: "Business",
    status: "Active",
    someName: "Mr.",
    firstName: "",
    lastName: "",
    companyName: "",
    displayName:"",
    customerName: "",
    email: "",
    workphone: "",
    mobile: "",
    designation: "",
    department: "",
    website: "",
    currency: "INR- Indian Rupee",
    openingBalance: "0",
    paymentTerms: "",
    facebook: "",
    twitter: "",
    billAttention: "",
    billCountry: "India",
    billAddress1: "",
    billAddress2: "",
    billCity: "",
    billState: "Maharashtra",
    billZipcode: "",
    billPhone: "",
    billFax: "",
    shipAttention: "",
    shipCountry: "India",
    shipAddress1: "",
    shipAddress2: "",
    shipCity: "",
    shipState: "Maharashtra",
    shipZipcode: "",
    shipPhone: "",
    shipFax: "",
    gstin: "",
    pan: "",
    placeOfSupply: "[MH] - Maharashtra",
    taxable: "",
    reason: "N/A",
    activeStatus: "Active",
    gstTreatment: "",
    contactPerson: [
      {
        other: "",
        otherFirstname: "",
        otherLastname: "",
        otherEmail: "",
        otherWorkphone: "",
        otherMobile: "",
      },
    ],
  });
  const [userDetails, setUserDetails] = useState([
    {
      itemDetails: "",
      itemCode:"",
      batchId: "",
      hsnSac: "",
      size: "",
      per:"",
      quantity: "",
      rate: "",
      rateOne: "",
      pack: "",
      discount: "",
      discountType: "%",
      tax: "",
      selectedTaxRate: 0,
      description1: "",
      description2: "",
      alternateUnit: "", // Add this
      alternateUnitValue: "0.0", // Add this
      calculatedAltUnitValue: "0.0", // Add this
      singleAltUnitValue: "0.0",
      hasAlternateUnit: "",
    },
  ]);
  const [deletedItems, setDeletedItems] = useState([]); // State to store deleted items

  const [ids, setIds] = useState([]);
  const { invoiceNumber1 } = props;
  const [validationMessage1, setValidationMessage1] = useState("");

  const insertDataIntoDatabaseAsDraft = async (e) => {
    e.preventDefault();
    const formDataObject = {
      uniqueId: decryptedUniqueId,
      items: userDetails.map((userDetail, index) => {
        const amount1 = calculateAmount(userDetail, userDetail.tax);
      const taxinAmount = calculateTAX(userDetail);
      const totalAmountWithTax = parseFloat(amount1) + parseFloat(taxinAmount);
        return {
          itemId: userDetail.itemId || 0,
          itemDetails: userDetail.itemDetails || "",
          batchId: userDetail.batchId,
          itemCode: userDetail.itemCode || "",
          rateOne: userDetail.rateOne,
          pack: userDetail.pack,
          hsnSac: userDetail.hsnSac || "",
          size: userDetail.size || "",
          per: userDetail.per || "",
          quantity: userDetail.quantity || "",
          oldItemQuantity: oldQuantities[index] || "0",
          rate: userDetail.rate || formData.rate,
          discount: userDetail.discount || formData.discount,
          discountType: userDetail.discountType || formData.discountType,
          tax: userDetail.tax || formData.selectedTaxRate,
          rowDiscount: calculateDisRupees(userDetail),
          amount: amount1,
        rowWiseTotalWithGST: totalAmountWithTax.toFixed(2),
          description1: userDetail.description1 || "",
          description2: userDetail.description2 || "",
          cgst:
            userState.state === customerState
              ? (amount1 * userDetail.tax) / 100 / 2
              : 0,
          sgst:
            userState.state === customerState
              ? (amount1 * userDetail.tax) / 100 / 2
              : 0,
          igst:
            userState.state !== customerState
              ? (amount1 * userDetail.tax) / 100
              : 0,
          alternateUnitValue: userDetail.calculatedAltUnitValue,
          alternateUnit: userDetail.alternateUnit,
        };
      }),
      ids: ids.map((id) => ({ id })),
      customerName: fetchedCustomerName || formData.customerName,
      customerId: selectedCustomerId || formData.customerId,
      invoiceNumber: formData.invoiceNumber,
      state: customerState,
      oldInvoiceNumber: fetchedInvoiceNumber,
      invoiceDate: dateValue || formData.invoiceDate,
      terms: fetchedPaymentTerms || formData.terms,
      dueDate: showDueDate
        ? formData.dueDate
        : dateValue1
        ? dateValue1
        : normalDateFormat(startDate1),
      salesPerson: formData.salesPerson,
      orderNumber: formData.orderNumber,
      subject: formData.subject,
      inquiryId: formData.inquiryId,
      subtotal: calculateSubTotal(),
      adjustment: formData.adjustment,
      adjustmentLabel: formData.adjustmentLabel,
      total: total,
      overallDiscount: disValue || 0,
      totalDiscount: disAllValue || 0,
      totalDiscountType: discountType,
      taxInAmount: totalTax || 0,
      type: tType || formData.type,
      customerNote: formData.customerNote,
      termsAndCondition: content,
      value: formData.type === "TCS" ? discountAmountTcs : discountAmountTds,
      tdsTax: selectedTdsOption?.value,
      tcsTax: selectedTcsOption?.value,
      taxCheck: bussinessRegistered,
      discountCheck: discountCheck,
      sizeCheck: sizeCheck,
      status: "Draft",
      manualCheck: manualCheck,
      batchIdCheck: batchIdCheck,
      netRateCheck: netRateCheck,
      manage: deletedItems,
      gstNumber: formData.gstNumber,
      packCheck: packCheck,
      quantityCheck:quantityCheck,
      hsnCheck: hsnCheck,
    };

    let newValidationMessage = "";
    if (!formData.customerName) {
      newValidationMessage += "Please select a customer.\n";
    } else if (!formData.invoiceNumber) {
      newValidationMessage += "Please enter invoice number.\n";
    } else if (!formData.invoiceDate) {
      newValidationMessage += "Please select a invoice date.\n";
    }

    userDetails.forEach((item, index) => {
      if (item.itemDetails.trim() === "") {
        newValidationMessage += `Item name is required.\n`;
      }
      if (item.rate.trim() === "") {
        newValidationMessage += `Rate is required.\n`;
      } else if (item.rate.trim() === "0.0") {
        newValidationMessage += `Rate cannot be 0.0.\n`;
      }
      if (item.quantity.trim() === "") {
        newValidationMessage += `Quantity is required.\n`;
      }
    });

    setValidationMessage1(newValidationMessage);

    if (newValidationMessage) {
      window.scrollTo(0, 0);
      return;
    }
    setIsLoading2(true);
    try {
      const response = await fetch(BASE_URL + "/updateInvoices", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(formDataObject),
      });

      if (response.ok) {
        swal({
          icon: "success",
          title: `Invoice  Updated`,
        });
        props.handleCancel();
        setIsLoading2(false);
      } else {
        swal({
          icon: "error",
          title: `Failed to Update Invoice`,
        });
        setIsLoading2(false);
      }
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  const insertDataIntoDatabase = async (e) => {
    e.preventDefault();
    const formDataObject = {
      uniqueId: decryptedUniqueId,
      items: userDetails.map((userDetail, index) => {
        const amount1 = calculateAmount(userDetail, userDetail.tax);
      const taxinAmount = calculateTAX(userDetail);
      const totalAmountWithTax = parseFloat(amount1) + parseFloat(taxinAmount);
        return {
          itemId: userDetail.itemId || 0,
          itemDetails: userDetail.itemDetails || "",
          hsnSac: userDetail.hsnSac || "",
          itemCode: userDetail.itemCode || "",
          size: userDetail.size || "",
          per: userDetail.per || "",
          quantity: userDetail.quantity || "",
          rateOne: userDetail.rateOne,
          pack: userDetails.pack,
          batchId: userDetails.batchId,
          oldItemQuantity: oldQuantities[index] || "0",
          rate: userDetail.rate || formData.rate,
          discount: userDetail.discount || formData.discount,
          discountType: userDetail.discountType || formData.discountType,
          tax: userDetail.tax || formData.selectedTaxRate,
          rowDiscount: calculateDisRupees(userDetail),
          amount: amount1,
        rowWiseTotalWithGST: totalAmountWithTax.toFixed(2),
          description1: userDetail.description1 || "",
          description2: userDetail.description2 || "",
          cgst:
            userState.state === customerState
              ? (amount1 * userDetail.tax) / 100 / 2
              : 0,
          sgst:
            userState.state === customerState
              ? (amount1 * userDetail.tax) / 100 / 2
              : 0,
          igst:
            userState.state !== customerState
              ? (amount1 * userDetail.tax) / 100
              : 0,
          alternateUnitValue: userDetail.calculatedAltUnitValue,
          alternateUnit: userDetail.alternateUnit,
        };
      }),
      ids: ids.map((id) => ({ id })),
      customerName: fetchedCustomerName || formData.customerName,
      customerId: selectedCustomerId || formData.customerId,
      invoiceNumber: formData.invoiceNumber,
      state: customerState,
      oldInvoiceNumber: fetchedInvoiceNumber,
      invoiceDate: dateValue || formData.invoiceDate,
      terms: fetchedPaymentTerms || formData.terms,
      dueDate: showDueDate
        ? formData.dueDate
        : dateValue1
        ? dateValue1
        : normalDateFormat(startDate1),
      salesPerson: formData.salesPerson,
      orderNumber: formData.orderNumber,
      subject: formData.subject,
      inquiryId: formData.inquiryId,
      subtotal: calculateSubTotal(),
      adjustment: formData.adjustment,
      adjustmentLabel: formData.adjustmentLabel,
      total: total,

      overallDiscount: disValue || 0,
      totalDiscount: disAllValue || 0,
      totalDiscountType: discountType,
      taxInAmount: totalTax || 0,
      type: tType || formData.type,
      customerNote: formData.customerNote,
      termsAndCondition: content,
      value: formData.type === "TCS" ? discountAmountTcs : discountAmountTds,
      tdsTax: selectedTdsOption?.value,
      tcsTax: selectedTcsOption?.value,
      taxCheck: bussinessRegistered,
      discountCheck: discountCheck,
      sizeCheck: sizeCheck,
      status: "Sent",
      manualCheck: manualCheck,
      netRateCheck: netRateCheck,
      batchIdCheck: batchIdCheck,
      manage: deletedItems,
      gstNumber: formData.gstNumber,
      packCheck: packCheck,
      quantityCheck:quantityCheck,
    };
    
    let newValidationMessage = "";
    if (!formData.customerName) {
      newValidationMessage += "Please select a customer.\n";
    } else if (!formData.invoiceNumber) {
      newValidationMessage += "Please enter invoice number.\n";
    } else if (!formData.invoiceDate) {
      newValidationMessage += "Please select a invoice date.\n";
    }

    userDetails.forEach((item, index) => {
      if (item.itemDetails.trim() === "") {
        newValidationMessage += `Item name is required.\n`;
      }
      if (item.rate.trim() === "") {
        newValidationMessage += `Rate is required.\n`;
      } else if (item.rate.trim() === "0.0") {
        newValidationMessage += `Rate cannot be 0.0.\n`;
      }
      if (item.quantity.trim() === "") {
        newValidationMessage += `Quantity is required.\n`;
      }
    });

    setValidationMessage1(newValidationMessage);

    if (newValidationMessage) {
      window.scrollTo(0, 0);
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(BASE_URL + "/updateInvoices", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(formDataObject),
      });

      if (response.ok) {
        swal({
          icon: "success",
          title: `Invoice  Updated`,
        });
        props.handleCancel();
        setIsLoading(false);
      } else {
        swal({
          icon: "error",
          title: `Failed to Update Invoice`,
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  const [taxGroups, setTaxGroups] = useState({});

  useEffect(() => {
    const formattedId = invoiceNumber1.replace(/\//g, "!");
    fetch(BASE_URL + `/fetchInvoiceNumber/${formattedId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setUserDetails(data.responseMessage);

          const updatedItems = data.responseMessage.map((item) => {
            const quantity = parseFloat(item.quantity) || 1;
            const alterUV = parseFloat(item.alternateUnitValue) || 0;
            // Only calculate singleAltUnitValue if this item actually has an alternateUnitValue
            const hasAltUnit = item.alternateUnit && item.alternateUnitValue;
            const singleUV =
              hasAltUnit && quantity > 0 ? alterUV / quantity : 0;

            return {
              ...item,
              calculatedAltUnitValue: alterUV,
              singleAltUnitValue: singleUV,
              hasAlternateUnit: hasAltUnit, // Flag to check if this item has an alternate unit
            };
          });
          setUserDetails(updatedItems);

          setItemDescriptions(
            data.responseMessage.map((item) => ({
              itemDetails: item.itemDetails,
              description: item.description2 || "",
            }))
          );
          const itemIds = data.responseMessage.map((item) => item.id);
          setIds(itemIds);
          setOldQuantities(data.responseMessage.map((item) => item.quantity));
          const Data = data.responseMessage[0];
          setBussinessRegistered(Data.taxCheck);
          setDiscountCheck(Data.discountCheck);
          setSizeCheck(Data.sizeCheck);
          setHsnCheck(Data.hsnCheck);
          setQuantityCheck(Data.quantityCheck);
          setCustomerState(Data.state);
          setNetRateCheck(Data.netRateCheck);
          setBatchIdCheck(Data.batchIdCheck);
          setPackCheck(Data.packCheck);
          setContent(Data.termsAndCondition);
          setFormData({
            customerName: Data.customerName,
            customerId: Data.customerId,
            invoiceNumber: Data.invoiceNumber,
            state: Data.state,
            orderNumber: Data.orderNumber,
            invoiceDate: Data.invoiceDate,
            dueDate: Data.dueDate,
            salesPerson: Data.salesPerson,
            subject: Data.subject,
            inquiryId: Data.inquiryId,
            customerNote: Data.customerNote,
            adjustment: Data.adjustment,
            adjustmentLabel: Data.adjustmentLabel,
            subtotal: Data.subtotal,
            total: Data.total,
            igst: Data.igst,
            cgst: Data.cgst,
            sgst: Data.sgst,
            type: Data.type,
            termsAndCondition: Data.termsAndCondition,
            terms: Data.terms,
            taxInAmount: Data.taxInAmount,
            tax: Data.tax,
            tcsTax: Data.tcsTax,
            tdsTax: Data.tdsTax,
            value: Data.value,
            status: Data.value,
            gstNumber: Data.gstNumber,
          });
          setSelectedCustomerId(Data.customerId);
          setDisAllValue(Data.totalDiscount);
          setDiscountType(Data.totalDiscountType);
          setFetchedCustomerName(Data.customerName);
          setFetchedSalesPerson(Data.salesPerson);
          setFetchedPaymentTerms(Data.terms);
          setFetchedInvoiceNumber(Data.invoiceNumber);
          const inputDateString = Data.invoiceDate;
          const parts = inputDateString.split("-");
          const formattedDate = new Date(
            `${parts[2]}-${parts[1]}-${parts[0]}`
          ).toString();
          setOriginal(formattedDate);
          // if (Data.tcsTax !== null) {
          const selectedTcsOption = tcs.find(
            (option) => option.value === Data.tcsTax
          );
          setSelectedTcsOption(selectedTcsOption);
          setDiscountAmountTcs(parseFloat(Data.value));
          // } else if (Data.tdsTax !== null) {
          const selectedTdsOption = tds.find(
            (option) => option.value === Data.tdsTax
          );
          setSelectedTdsOption(selectedTdsOption);
          setDiscountAmountTds(parseFloat(Data.value));
          const taxGroups = calculateGroupedSGSTandCGST(data.responseMessage);
          setTaxGroups(taxGroups);
          // }
        } else {
          console.error(
            "Failed to fetch invoices by id:",
            data.responseMessage
          );
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching invoices:", error);
        setLoading(false);
      });
  }, []);

  const [fetchedCustomerName, setFetchedCustomerName] = useState("");
  const [fetchedInvoiceNumber, setFetchedInvoiceNumber] = useState("");
  const [fetchedPaymentTerms, setFetchedPaymentTerms] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    if (name === "adjustment") {
      setAdjustmentValue(value);
    }
  };

  const handleSalesInputChange = (event) => {
    const { name, value } = event.target;
    setSalesData({ ...salesData, [name]: value });
  };

  const [showSalesModal, setShowSalesModal] = useState(false);

  const handleSalesClose = () => setShowSalesModal(false);
  const handleSalesShow = () => setShowSalesModal(true);
  const [validationMessage2, setValidationMessage2] = useState("");

  const handleSalesPerson = (event) => {
    event.preventDefault();
    let newValidationMessage = "";

    if (!salesData.name) {
      newValidationMessage += "Please enter a name.\n";
    }

    setValidationMessage2(newValidationMessage);

    // Display a single validation alert if necessary
    if (newValidationMessage) {
      // alert(newValidationMessage.trim()); // Trim trailing newline for better formatting
      return; // Exit function if validation fails
    }
    fetch(BASE_URL + "/createSalesperson", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(salesData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          swal({
            icon: "success",
            title: "Sales Person Created",
          });
          setShowSalesModal(false);
          fetchAllSalesPerson();
          closePopup();
        } else {
          swal({
            icon: "error",
            title: "Failed To Create Sales Person!",
          });
          setShowSalesModal(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        swal({
          icon: "error",
          title: "An Error Occured While Creating Sales Person ",
        });
        setShowSalesModal(true);
      });
  };

  const [salesData, setSalesData] = useState({
    uniqueId: decryptedUniqueId,
    name: "",
    email: "",
  });

   const [searchTermItemCode, setSearchTermItemCode] = useState("");
    const [searchResultsItemCode, setSearchResultsItemCode] = useState([]);
    const [searchPerformedItemCode, setSearchPerformedItemCode] = useState(false);
    const [searchIndexItemCode, setSearchIndexItemCode] = useState(0);

  const handleItemCodeChange = (e, i) => {
    const value = e.target.value;
    const newDetails = [...userDetails];
    newDetails[i].itemCode = value;
    setUserDetails(newDetails);
    setSearchTermItemCode(value);
    setSearchPerformedItemCode(value !== "");
    setSearchIndexItemCode(i);

    if (value) {
      fetchItemByCode(value, i);
    }
  };

  const handleItemCodeSelect = (selectedItem, selectedItemId, index) => {
    setSearchResultsItemCode([]);
    const newDetails = [...userDetails];
    newDetails[index].itemCode = selectedItem;
    setUserDetails(newDetails);
    fetchItemRate(selectedItemId, index);
  };

  const fetchItemByCode = (itemCode, index) => {
    const results = dropdownData.filter(
      (item) =>
        item.itemCode &&
        item.itemCode.toLowerCase().includes(itemCode.toLowerCase())
    );
    setSearchResultsItemCode(results);
  };

  const handleInputChangess = (e, i) => {
    const { name, value } = e.target;
    const updatedUserDetails = [...userDetails]; // Create a copy of the state array
    updatedUserDetails[i][name] = value; // Update the specific property

    if (name === "quantity") {
      const quantity = parseFloat(value) || 0;
      // Only calculate if this item has an alternate unit
      if (
        updatedUserDetails[i].hasAlternateUnit ||
        updatedUserDetails[i].alternateUnit
      ) {
        const singleUV = updatedUserDetails[i].singleAltUnitValue || 0;
        const newAlternateUnitValue = quantity * singleUV;
        updatedUserDetails[i].calculatedAltUnitValue = newAlternateUnitValue;
      }
    }

    setUserDetails(updatedUserDetails); // Update the state with the modified data
    if (name === "tax") {
      const taxRate = parseFloat(value);
      setSelectedTaxRate(taxRate);
    }
  };

  const handleHsnSacChange = (e, i) => {
    const { value } = e.target;
    const newRow = [...row];
    newRow[i] = { ...newRow[i], hsnSac: value };
    setRow(newRow);
  };

  const [salesPersonData, setSalesPersonData] = useState([]);
  const [selectedSalesPerson, setSelectedSalesPerson] = useState("");

  const handleSalesPersonChange = (value, id) => {
    const selectedValue = value;
    setSelectedSalesPerson(selectedValue);
    setFetchedSalesPerson(selectedValue);
    setFormData({ ...formData, salesPerson: selectedValue });
    const selectedSalesPersonObject = salesPersonData.find(
      (person) => person.name === selectedValue
    );
  };

  const fetchAllSalesPerson = () => {
    fetch(BASE_URL + `/getAllSalesPersonByUniqueId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const filteredData = data.responseMessage.filter(
            (item) => item.name !== "Others"
          );
          setSalesPersonData(filteredData);
        } else {
          console.error("Failed to fetch salesperson:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching salesperson:", error);
      });
  };
  useEffect(() => {
    fetchAllSalesPerson();
  }, []);

  const [custNames, setCustNames] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState(""); // State to store the selected customer's ID

  const fetchAllCustomers = () => {
    fetch(BASE_URL + `/getAllCustomerName`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setCustNames(data.responseMessage);
        } else {
          console.error("Failed to fetch Customer Name:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching Customer Name:", error);
      });
  };
  useEffect(() => {
    fetchAllCustomers();
  }, []);

  useEffect(() => {
    if (fetchedCustomerName) {
      const selectedCustomerObject = custNames.find(
        (person) => person.customerName === fetchedCustomerName
      );

      if (selectedCustomerObject) {
        const customerState = selectedCustomerObject.billState;
        setCustomerState(customerState);
      }
    }
  }, [fetchedCustomerName, custNames]);

  const handleCustomerChange = (selectedOption) => {
    const selectedValue = selectedOption.value;
    setSelectedCustomer(selectedValue);
    setFetchedCustomerName(selectedValue);
    // Assuming you have a state `formData` which includes customerName
    setFormData((prevFormData) => ({
      ...prevFormData,
      customerName: selectedValue,
    }));
    const selectedCustomerObject = custNames.find(
      (person) => person.customerName === selectedValue
    );
    const fetchId = formData.customerId;
    const selectId = selectedCustomerObject.id;

    if (fetchId == selectId) {
      setCustomerState(formData.state);
      setSelectedCustomerId(selectedCustomerObject.id);
      setSelectedTerms(selectedCustomerObject.paymentTerms);
    } else if (selectedCustomerObject) {
      const customerState = selectedCustomerObject.billState;
      const customerTerms = selectedCustomerObject.paymentTerms;
      setCustomerState(customerState);
      setSelectedCustomerId(selectedCustomerObject.id);
      setSelectedTerms(customerTerms);
    }
  };

  //Change Term
  const handleTermChange = (event) => {
    const selectedTerm = event.target.value;
    setSelectedTerms(selectedTerm);

    setFormData({ ...formData, terms: selectedTerm });

    if (selectedTerm.startsWith("Net ")) {
      const daysToAdd = parseInt(selectedTerm.replace("Net ", ""));
      // setDueDate(addDays(new Date(), daysToAdd));
      setFormData({
        ...formData,
        dueDate: addDays(new Date(), daysToAdd).toISOString().substr(0, 10),
      });
    } else if (selectedTerm === "Due End Of The Month") {
      // setDueDate(endOfMonth(new Date()));
      setFormData({
        ...formData,
        dueDate: endOfMonth(new Date()).toISOString().substr(0, 10),
      });
    } else if (selectedTerm === "Due End Of Next Month") {
      // setDueDate(endOfMonth(addMonths(new Date(), 1)));
      setFormData({
        ...formData,
        dueDate: endOfMonth(addMonths(new Date(), 1))
          .toISOString()
          .substr(0, 10),
      });
    } else if (selectedTerm === "Due On Receipt") {
      // setDueDate(new Date());
      setFormData({
        ...formData,
        dueDate: new Date().toISOString().substr(0, 10),
      });
    } else {
      setDueDate(null);
      // setFormData({...formData,dueDate:null})
    }
  };

  // const handleTaxChange = (e, rowIndex) => {
  //   const { value } = e.target;
  //   const updatedUserDetails = [...userDetails];
  //   updatedUserDetails[rowIndex].tax = value;
  //   updatedUserDetails[rowIndex].selectedTaxRate = parseFloat(value);
  //   setUserDetails(updatedUserDetails);
  // };

  const [once, setOnce] = useState(true);
  const handleTaxChange = (e, index) => {
    setOnce(false);
    setSelectedTaxRate(e.target.value);
    const newTaxRate = parseFloat(e.target.value);
    const updatedRow = [...userDetails];
    updatedRow[index].tax = newTaxRate;
    setUserDetails(updatedRow);
    calculateIGST();
  };

  const calculateDisRupees = (data, taxRate) => {
    const quantity = parseFloat(data.quantity || 0);
    const rate = parseFloat(data.rate || 0);
    const discount = parseFloat(data.discount || 0);
    const amount = quantity * rate;
    let discountedAmount = 0;
    if (data.discountType === "%") {
      discountedAmount = (amount * discount) / 100;
    } else if (data.discountType === "₹") {
      discountedAmount = discount;
    }

    return discountedAmount.toFixed(2);
  };

  // => IGST - 1
  // const calculateIGST = () => {
  //   let totalIGST = 0;

  //   userDetails.forEach((data) => {
  //     const taxRate = parseFloat(data.tax || 0);
  //     const amount = calculateAmount(data, taxRate);
  //     totalIGST += parseFloat(amount) - amount / (1 + taxRate); // Subtract the original tax amount
  //   });

  //   return totalIGST.toFixed(2);
  // };

  const calculateIGST = () => {
    let totalIGST = 0;

    userDetails.forEach((data) => {
      const taxRate = parseFloat(data.tax || 0);
      if (taxRate > 0) {
        const amount = calculateAmount(data, taxRate);
        // const increasedTaxAmount = amount * taxRate;
        const increasedTaxAmount = (parseFloat(amount) * taxRate) / 100;
        totalIGST += increasedTaxAmount;
      }
    });

    return totalIGST.toFixed(2);
  };

  const calculateIGSTForTax = () => {
    const taxResults = [];

    userDetails.forEach((data) => {
      const taxRate = parseFloat(data.tax / 100 || 0);
      if (taxRate > 0) {
        let existingTaxResult = taxResults.find(
          (result) => result.taxRate === taxRate
        );
        if (!existingTaxResult) {
          existingTaxResult = { taxRate, totalIGST: 0 };
          taxResults.push(existingTaxResult);
        }
        const amount = calculateAmount(data, taxRate);
        const increasedTaxAmount = amount * taxRate;
        existingTaxResult.totalIGST += increasedTaxAmount;
      }
    });
    return taxResults;
  };

  //CalculateSGST
  const calculateSGST = () => {
    let totalSGST = 0;
    row.forEach((data) => {
      const taxRate = parseFloat(data.tax || 0);
      const amount = calculateAmount(data, taxRate);
      const taxAmount = calculateTaxAmount(parseFloat(amount), taxRate);
      const sgstAmount = taxAmount / 2; // Assuming SGST is half of the total tax amount
      totalSGST += sgstAmount;
    });
    return totalSGST.toFixed(2);
  };

  //Calculate CGST
  const calculateCGST = () => {
    let totalCGST = 0;
    row.forEach((data) => {
      const taxRate = parseFloat(data.tax || 0);
      const amount = calculateAmount(data, taxRate);
      const taxAmount = calculateTaxAmount(parseFloat(amount), taxRate);
      const cgstAmount = taxAmount / 2;
      totalCGST += cgstAmount;
    });
    return totalCGST.toFixed(2);
  };

  //calculate SGST and CGSt
  const calculateSGSTandCGST = () => {
    let totalSGST = 0;
    let totalCGST = 0;

    userDetails.forEach((data) => {
      const taxRate = parseFloat(data.tax || 0);
      const amount = calculateAmount(data, taxRate);
      // const increasedTaxAmount = parseFloat(amount) - amount / (1 + taxRate);
      const increasedTaxAmount = (parseFloat(amount) * taxRate) / 100;
      const sgst = increasedTaxAmount / 2;
      const cgst = increasedTaxAmount / 2;
      totalSGST += sgst;
      totalCGST += cgst;
    });
    return {
      totalSGST: totalSGST.toFixed(2),
      totalCGST: totalCGST.toFixed(2),
    };
  };

  const calculateGroupedSGSTandCGST = (rows) => {
    const taxGroups = userDetails.reduce((acc, data) => {
      const taxRate = parseFloat(data.tax / 100 || 0);
      if (taxRate === 0) return acc; // Skip 0% GST

      const amount = calculateAmount(data, taxRate);
      const increasedTaxAmount = amount * taxRate;
      const sgst = increasedTaxAmount / 2;
      const cgst = increasedTaxAmount / 2;

      if (!acc[taxRate]) {
        acc[taxRate] = { totalSGST: 0, totalCGST: 0 };
      }

      acc[taxRate].totalSGST += sgst;
      acc[taxRate].totalCGST += cgst;

      return acc;
    }, {});

    return taxGroups;
  };

  const [itemName, setItemName] = useState("");
  const [showItemModal, setShowItemModal] = useState(false);

  const [itemData, setItemData] = useState({
    uniqueId: decryptedUniqueId,
    description: "",
  });

  const handleItemClose = () => {
    setShowItemModal(false);
    setItemData({
      ...itemData,
      description: "",
    });
  };

  const handleItemChange = (event) => {
    const { name, value } = event.target;
    setItemData({ ...itemData, [name]: value });
  };

  const [itemDescriptions, setItemDescriptions] = useState([]);

  const handleItem = (event) => {
    event.preventDefault();

    const newItemDescription = {
      itemDetails: itemName,
      description: itemData.description,
    };

    setItemDescriptions((prevDescriptions) => {
      const existingIndex = prevDescriptions.findIndex(
        (desc) => desc.itemDetails === itemName
      );

      if (existingIndex !== -1) {
        // Update existing description
        const updatedDescriptions = [...prevDescriptions];
        updatedDescriptions[existingIndex] = newItemDescription;
        return updatedDescriptions;
      } else {
        // Add new description
        return [...prevDescriptions, newItemDescription];
      }
    });

    // Update the description2 in the userDetails
    setUserDetails((prevRows) => {
      return prevRows.map((row) =>
        row.itemDetails === itemName
          ? { ...row, description2: itemData.description }
          : row
      );
    });
    setShowItemModal(false);
    closePopup();
  };

  const handleItemShow = (itemDetails) => {
    const itemDescription = itemDescriptions.find(
      (desc) => desc.itemDetails === itemDetails
    );
    if (itemDescription) {
      setItemData({ description: itemDescription.description });
    } else {
      setItemData({ description: "" });
    }
    setItemName(itemDetails);
    setShowItemModal(true);
  };

  const [dropdownData, setDropdownData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchPerformed, setSearchPerformed] = useState(false);

  const [selectedItem, setSelectedItem] = useState("");
  const [assignedField, setAssignedField] = useState("");
  const [selectedItems, setSelectedItems] = useState(
    Array(row.length).fill("")
  );

  const fetchItemData = () => {
    const postApiUrl = BASE_URL + `/getAllItemData`;

    fetch(postApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId, vendorId: "" }),
    })
      .then((response) => response.json())
      .then((data) => {
        const responseData = data.responseMessage;
        setDropdownData(responseData.map((item) => item));
      })
      .catch((error) => {
        console.error("Error making POST request:", error);
      });
  };

  useEffect(() => {
    fetchItemData();
  }, []);

  const [searchIndex, setSearchIndex] = useState(0);

  useEffect(() => {
    const results = dropdownData.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(results);
  }, [searchTerm, dropdownData]);

  const handleSearchChange = (e, index) => {
    const value = e.target.value;
    const newRow = [...userDetails];
    newRow[index].itemDetails = value;
    setUserDetails(newRow);
    setSearchTerm(value);
    setSearchPerformed(value !== "");
    setSearchIndex(index);
  };

  // const handleItemDetailsChange = (e, index) => {
  //   handleSearchChange(e, index);
  // };

  const handleItemDetailsChange = (e, index) => {
    const value = e.target.value;
    const newRow = [...userDetails];
    newRow[index].itemDetails = value;
    setUserDetails(newRow);
    setSearchTerm(value);
    setSearchPerformed(value !== "");
    setSearchIndex(index);
    if (value) {
      fetchItemRate(value, index);
    } else {
      handleSearchChange(value, index);
    }
  };

  const handleItemSelect = (selectedItem, selectedItemId, index) => {
    setSearchResults([]);
    const newRow = [...userDetails];
    newRow[index].itemDetails = selectedItem;
    setUserDetails(newRow);
    fetchItemRate(selectedItemId, index);
  };

  const fetchItemRate = (itemId, index) => {
    const getApiUrl = BASE_URL + `/getItemData/${itemId}`;

    fetch(getApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const rate = data.data.taxableAmount;
        const itemCode = data.data.itemCode;
        const hsnSac = data.data.hsnCode;
        const description1 = data.data.description;
        const itemName = data.data.name;
        const tax = data.data.intraStateTaxRate;
        const itemId = data.data.id;
        const pack = data.data.pack;
        const make = data.data.make;
        const alternateUnitValue = data.data.alternateUnitValue;
        const alternateUnit = data.data.alternateUnit;
        const singleAltUnitValue = data.data.alternateUnitValue;
        const updatedRow = [...userDetails];
        updatedRow[index].rate = rate;
        updatedRow[index].itemCode = itemCode;
        updatedRow[index].description1 = description1;
        updatedRow[index].hsnSac = hsnSac;
        updatedRow[index].itemDetails = itemName;
        updatedRow[index].tax = tax;
        updatedRow[index].itemId = itemId;
        updatedRow[index].pack = pack;
        updatedRow[index].make = make;
        updatedRow[index].alternateUnitValue = alternateUnitValue;
        updatedRow[index].alternateUnit = alternateUnit;
        updatedRow[index].calculatedAltUnitValue = alternateUnitValue;
        updatedRow[index].singleAltUnitValue = singleAltUnitValue;
        setUserDetails(updatedRow);
        setSearchResults([]);
        handleAdd();
      })
      .catch((error) => {
        console.error("Error making POST request:", error);
      });
  };

  function convertDateStringToDate(dateString) {
    if (!dateString) {
      return null;
    }
    const [day, month, year] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  const dateObject = convertDateStringToDate(formData.invoiceDate);

  const [showDueDate, setShowDueDate] = useState(true);
  const [showInvDate, setShowInvDate] = useState(true);
  const [showDuePerTerm, setShowDuePerTerm] = useState(false);
  const [original, setOriginal] = useState(null);

  const updateDueDate = (date, terms) => {
    setDueDateChangedManually(false);
    if (terms.startsWith("Net ")) {
      const daysToAdd = parseInt(terms.replace("Net ", ""));
      setDueDate(
        normalDateFormat(
          addDays(showDuePerTerm == true ? startDate : dateObject, daysToAdd)
        )
      );
      setShowDueDate(true);
    } else if (terms === "Due End Of The Month") {
      setDueDate(
        normalDateFormat(
          endOfMonth(showDuePerTerm == true ? startDate : dateObject)
        )
      );
      setShowDueDate(true);
    } else if (terms === "Due End Of Next Month") {
      setDueDate(
        normalDateFormat(
          endOfMonth(
            addMonths(showDuePerTerm == true ? startDate : dateObject, 1)
          )
        )
      );
      setShowDueDate(true);
    } else if (terms === "Due On Receipt") {
      setDueDate(normalDateFormat(startDate));
      setShowDueDate(true);
    } else if (terms === "Custom") {
      setShowDueDate(false);
    } else {
      setDueDate("");
    }
  };

  const updateDueDate1 = (date, terms) => {
    setDueDateChangedManually(false);
    if (terms.startsWith("Net ")) {
      const daysToAdd = parseInt(terms.replace("Net ", ""));
      setDueDate(normalDateFormat(addDays(date, daysToAdd)));
      setShowDueDate(true);
    } else if (terms === "Due End Of The Month") {
      setDueDate(normalDateFormat(endOfMonth(date)));
      setShowDueDate(true);
    } else if (terms === "Due End Of Next Month") {
      setDueDate(normalDateFormat(endOfMonth(addMonths(date, 1))));
      setShowDueDate(true);
    } else if (terms === "Due On Receipt") {
      setDueDate(normalDateFormat(date));
      setShowDueDate(true);
    } else if (terms === "Custom") {
      setShowDueDate(false);
    } else {
      setDueDate("");
    }
  };

  useEffect(() => {
    if (currentDate && selectedTerms && !dueDateChangedManually) {
      updateDueDate(new Date(currentDate), selectedTerms);
    }
  }, [currentDate, selectedTerms, dueDateChangedManually]);

  const [startDate, setStartDate] = useState(new Date());
  const [startDate1, setStartDate1] = useState(new Date());

  useEffect(() => {
    setStartDate(new Date());
    setStartDate1(new Date());
  }, []);

  const [dateValue, setDateValue] = useState("");
  const [dateValue1, setDateValue1] = useState("");

  const handleDate = (date) => {
    setStartDate(date);
    setFormData({ ...formData, terms: selectedTerms || formData.terms });
    let normalFormat = date === null ? "" : normalDateFormat(date);

    setDateValue(normalFormat);
    updateDueDate1(date, selectedTerms || formData.terms);
  };

  const handleDate1 = (date) => {
    setStartDate1(date);
    let normalFormat = date === null ? "" : normalDateFormat(date);

    setDateValue1(normalFormat);
  };

  const normalDateFormat = (date) => {
    if (date) {
      return (
        ("0" + date.getDate()).slice(-2) +
        "-" +
        ("0" + (Number(date.getMonth()) + 1)).slice(-2) +
        "-" +
        date.getFullYear()
      );
    }
    return date;
  };

  const optionsCustomers = custNames.map((customer) => ({
    value: customer.customerName,
    label: customer.customerName,
  }));

  const optionPaymentTerms = [
    { value: "Net 15", label: "Net 15" },
    { value: "Net 30", label: "Net 30" },
    { value: "Net 45", label: "Net 45" },
    { value: "Net 60", label: "Net 60" },
    { value: "Due End Of The Month", label: "Due End Of The Month" },
    { value: "Due End Of Next Month", label: "Due End Of Next Month" },
    { value: "Due On Receipt", label: "Due On Receipt" },
    { value: "Custom", label: "Custom" },
  ];

  const handleChange = (event) => {
    // setSelectedOption(event.target.value);
    // const { name, value } = event.target;
    // setFormDataCustomer((prevData) => ({
    //   ...prevData,
    //   [name]: value,
    // }));

    const { name, value } = event.target;
  
    setFormDataCustomer((prevData) => {
      const newData = {
        ...prevData,
        [name]: value,
      };
      
      // If customerName is being changed, also update displayName with the same value
      if (name === 'customerName') {
        newData.displayName = value;
      }
      
      return newData;
    });
  };

  const applyDiscountTcs = (subtotal, discountPercentage) => {
    const discountAmount = (subtotal * discountPercentage) / 100;
    const tcsDis = (subtotal - discountAmount).toFixed(2);
    setDiscountAmountTcs(parseFloat(discountAmount.toFixed(2))); // Set discountAmount in state

    return tcsDis;
  };

  const calculateTotal2 = () => {
    const subTotal = parseFloat(calculateSubTotal());
    const igst = parseFloat(calculateIGST() || userDetails.igst);
    const adjustment = parseFloat(adjustmentValue || formData.adjustment) || 0; // Use the adjustment value if it's a valid number, otherwise, default to 0
    const total1 = subTotal + igst + adjustment;
    const total = total1 - disValue;
    const totalFinal = total - discountAmountTds;
    return totalFinal.toFixed(2);
  };

  const applyDiscount = (subtotal, discountPercentage) => {
    const discountAmount = (subtotal * discountPercentage) / 100;
    const tdsDis = (subtotal - discountAmount).toFixed(2);
    setDiscountAmountTds(parseFloat(discountAmount.toFixed(2))); // Set discountAmount in state

    return tdsDis;
  };

  const calculateDiscount = () => {
    const amount = parseFloat(calculateSubTotal()).toFixed(2);

    if (discountType === "₹") {
      setDisValue(disAllValue);
    } else if (discountType === "%") {
      const percentageDiscount = (amount * disAllValue) / 100;
      setDisValue(percentageDiscount.toFixed(2));
    }
  };

  const handleDisAllValueChange = (e) => {
    setDisAllValue(e.target.value);
  };

  const handleDiscountTypeChange = (e) => {
    setDiscountType(e.target.value);
  };

  const handleRadioClick = (taxType) => {
    setFormData({ ...formData, type: taxType });

    if (taxType === "TDS") {
      setSelectedTcsOption(null);
      setDiscountAmountTds(0);
      setDiscountAmountTcs(0);
    } else if (taxType === "TCS") {
      setSelectedTdsOption(null);
      setDiscountAmountTcs(0);
      setDiscountAmountTds(0);
    }

    setShowing1(taxType === "TDS");
    setShowing2(taxType === "TCS");
  };

  useEffect(() => {
    calculateDiscount();
  }, [disAllValue, discountType]);

  const handlePaymentChange = (selectedOption) => {
    setSelectedTerms(selectedOption.value);
    setFetchedPaymentTerms(selectedOption.value);
    updateDueDate(dateValue, selectedOption.value);
  };

  const optionSales = salesPersonData.map((person) => ({
    value: person.name,
    label: person.name,
  }));

  const customStyles2 = {
    container: (provided, state) => ({
      ...provided,
    }),
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      background: "#F6F6F6",
      borderRadius: "10px",
      // minHeight: "40px",
      height: "46px",
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      marginLeft: "8px",
      height: "46px",
      padding: "0 6px",
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      // height: "40px",
    }),
  };

  const customStyles3 = {
    container: (provided, state) => ({
      ...provided,
    }),
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      background: "#F6F6F6",
      borderRadius: "10px",
      // minHeight: "40px",
      height: "20px",
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      marginLeft: "8px",
      height: "20px",
      padding: "0 6px",
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      // height: "40px",
    }),
  };

  const [invoiceNumberPrefix, setInvoiceNumberPrefix] = useState([]);
  const [invoiceNumberNext, setInvoiceNumberNext] = useState([]);
  const [invoiceNumber, setInvoiceNumber] = useState("");

  const copyAdd = () => {
    if (show1) {
      setInvoiceNumber(invoiceNumberPrefix + invoiceNumberNext);
      setFormData({
        ...formData,
        invoiceNumber: invoiceNumberPrefix + invoiceNumberNext,
      });
      setManualCheck("No");
    } else {
      setManualCheck("Yes");
      setInvoiceNumber("");
      setFormData({
        ...formData,
        invoiceNumber: "",
      });
    }
  };

  const setBill = () => {
    setShow1(true);
    fetchBill();
  };

  const fetchBill = () => {
    const requestData = {
      uniqueId: decryptedUniqueId,
      type: "invoice",
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(requestData), // Convert the data to JSON format
    };

    fetch(BASE_URL + `/getCurruntNumberList2`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setInvoiceNumberPrefix(data.responseMessage.prefix);
        setInvoiceNumberNext(data.responseMessage.numbers);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  }; // Empty dependency array to fetch data once when the component mounts

  useEffect(() => {
    fetch(BASE_URL + `/getCurruntNumberList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ type: "invoice", uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setInvoiceNumber(data.responseMessage);
        } else {
          console.error("Failed to fetch numberList:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching Number List:", error);
      });
  }, []);

  const [validationMessage, setValidationMessage] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSaveClick = () => {
    let newValidationMessage = "";

    if (!formData.customerName) {
      newValidationMessage += "Please enter a customer display name.\n";
    } else if (
      formData.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
    ) {
      newValidationMessage += "Please enter a valid email address.\n";
    }

    setValidationMessage(newValidationMessage);

    // Display a single validation alert if necessary
    if (newValidationMessage) {
      window.scrollTo(0, 0);
      // alert(newValidationMessage.trim()); // Trim trailing newline for better formatting
      return; // Exit function if validation fails
    }

    fetch(BASE_URL + "/createCustomer", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(formDataCustomer),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          swal({
            icon: "success",
            title: "Customer Created",
            text: "",
          });
          setShow(false);
          fetchAllCustomers();
        } else if (data.responseCode === "400") {
          swal({
            icon: "error",
            title: "This email already exists, please insert another email.",
            text: "",
          });
          setShow(true);
        } else {
          swal({
            icon: "error",
            title: "Failed to Create Customer!",
            text: "",
          });
          setShow(true);
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: "Network Error",
          text: "An error occurred while communicating with the server.",
        });
        setShow(true);
      });
  };
  const generateNamePairs = () => {
    const { someName, firstName, lastName, companyName } = formData;
    const pairs = [];

    if (firstName && lastName) {
      pairs.push(`${someName} ${firstName} ${lastName}`);
      pairs.push(`${firstName} ${lastName}`);
      pairs.push(`${lastName} , ${firstName}`);
      pairs.push(`${companyName}`);
    }

    return pairs;
  };

  const totalTax =
    calculateIGST() ||
    calculateSGSTandCGST().totalSGST + calculateSGSTandCGST().totalCGST;

  useEffect(() => {
    if (
      (selectedTaxType === "TDS" || formData.type === "TDS") &&
      selectedTdsOption &&
      selectedTdsOption.discount
    ) {
      const subtotal = calculateSubTotal();
      const discountedTotal = applyDiscount(
        subtotal,
        selectedTdsOption.discount
      );
    } else if (
      (selectedTaxType === "TCS" || formData.type === "TCS") &&
      selectedTcsOption &&
      selectedTcsOption.discount
    ) {
      const subtotal = calculateSubTotal();
      const discountedTotal = applyDiscountTcs(
        subtotal,
        selectedTcsOption.discount
      );
    }
  }, [userDetails]);

  useEffect(() => {
    const newTotal =
      formData.type === "TCS" ? calculateTotal() : calculateTotal2();
    setTotal(newTotal);
  }, [
    formData,
    discountAmountTds,
    discountAmountTcs,
    calculateTotal,
    calculateTotal2,
  ]);
  const handleEditorChange = (value) => {
    setContent(value); // Update the state as content changes
  };

  return (
    <div>
      <Row>
        <Col>
          <div className="my-3">
            <div className="d-flex align-items-center ml-1 mt-4">
              <div
                className="cursor-pointer d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: "white",
                  borderRadius: "50%",
                  height: "35px",
                  width: "38px",
                }}
              >
                <ArrowBackIosIcon
                  width={2}
                  onClick={handleCancleClick}
                  className="arrow-child"
                />
              </div>
              <div className="newcustomer-head ml-2">
                <h5
                  className="ml-1 mb-0"
                  style={{ letterSpacing: "1px", color: "#086bd5de" }}
                >
                  Update Invoice
                </h5>
              </div>
            </div>
          </div>
          {validationMessage1 && (
            <Alert severity="error" className="mt-0">
              {validationMessage1.split("\n").map((message, index) => (
                <div key={index}>{message}</div>
              ))}
            </Alert>
          )}{" "}
          <Card className="card-style p-4">
            {/* <Card.Body> */}
            <Row>
              <Col className="" md="3">
                <Form.Group>
                  <label
                    className="text-primary"
                    style={{ fontSize: 16, fontWeight: "600" }}
                  >
                    CUSTOMER INFO
                  </label>
                </Form.Group>
              </Col>
            </Row>
            <Form>
              <Row>
                <Col className="" md="3">
                  <Form.Group>
                    <label
                      className="label-title"
                      style={{ fontSize: "14px", color: "grey" }}
                    >
                      Customer Name <span className="valid"> *</span>
                    </label>
                    <Select
                      // className="dropdown-field"
                      value={optionsCustomers.find(
                        (option) => option.value === fetchedCustomerName
                      )}
                      options={optionsCustomers}
                      onChange={(selectedOption) =>
                        handleCustomerChange(selectedOption)
                      }
                      placeholder="Select Customer"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: "#F6F6F6",
                          borderRadius: "7px",
                          height: "46px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          height: "19px",
                        }),
                      }}
                    />
                    <button
                      type="button"
                      class="btn p-0 text-left"
                      onClick={handleShow}
                    >
                      <span
                        class="text-primary"
                        style={{ fontSize: "12px", fontWeight: "500" }}
                      >
                        New Customer
                      </span>
                    </button>

                    {/* Add customer popup*/}
                    <Modal size="lg" show={show} onHide={handleClose}>
                      <div class="modal-header d-flex align-items-center pb-2 pt-2">
                        <h5 class="modal-title fs-5" id="newcustomerPopup">
                          New Customer
                        </h5>
                        <button
                          type="button"
                          className="btn pr-0"
                          onClick={handleClose}
                        >
                          <ion-icon
                            name="close-circle-outline"
                            size="large"
                            style={{ width: "28px" }}
                          ></ion-icon>
                        </button>
                      </div>
                      <Modal.Body className="p-0 pb-3">
                        {validationMessage && (
                          <Alert severity="error" className="mt-0">
                            {validationMessage
                              .split("\n")
                              .map((message, index) => (
                                <div key={index}>{message}</div>
                              ))}
                          </Alert>
                        )}{" "}
                        <div className="container">
                          <div className="row d-inline-flex">
                            <div className="modalinputchild">
                              <div className="text-style"> Salutation </div>
                              <select
                                className="form-control"
                                name="someName"
                                value={formData.someName}
                                onChange={handleChange}
                                style={{
                                  borderRadius: "9px",
                                  backgroundColor: "#f5f5f5",
                                  width: "200px",
                                  height: "35px",
                                  fontSize: "13px",
                                  marginTop: "10px",
                                }}
                              >
                                <option value="Mr.">Mr.</option>
                                <option value="Mrs.">Mrs.</option>
                                <option value="Ms.">Ms.</option>
                                <option value="Miss.">Miss.</option>
                                <option value="Dr.">Dr.</option>
                              </select>
                            </div>
                            <div className="modalinputchild">
                              <div className="text-style">First Name</div>
                              <input
                                className="form-control"
                                placeholder="First Name"
                                name="firstName"
                                id="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                type="text"
                              />
                            </div>
                            <div className="modalinputchild">
                              <div className="text-style">Last Name</div>
                              <input
                                className="form-control"
                                placeholder="Last Name"
                                id="lastName"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                type="text"
                              />
                            </div>
                          </div>
                          <div className="row d-inline-flex pt-2">
                            <div className="modalinputchild">
                              <div className="text-style"> Customer Email</div>
                              <input
                                className="form-control"
                                placeholder="Customer Email"
                                name="email"
                                type="text"
                                value={formData.email}
                                onChange={handleChange}
                              />
                            </div>

                            <div className="modalinputchild">
                              <div className="text-style">
                                {" "}
                                Customer Display Name
                                <span style={{ color: "red" }}> *</span>
                              </div>
                              <select
                                className="form-control cust"
                                name="customerName"
                                value={formData.customerName}
                                onChange={handleChange}
                                style={{
                                  borderRadius: "7px",
                                  backgroundColor: "#f5f5f5",
                                  width: "250px",
                                  height: "40px",
                                  fontSize: "13px",
                                  marginTop: "10px",
                                }}
                              >
                                <option>Select Names</option>
                                {generateNamePairs().map((pair, index) => (
                                  <option key={index} value={pair}>
                                    {pair}
                                  </option>
                                ))}
                              </select>{" "}
                            </div>
                            <div className="modalinputchild">
                              <div className="text-style">Company Name</div>
                              <input
                                className="form-control"
                                placeholder="Add company name"
                                name="companyName"
                                type="text"
                                value={formData.companyName}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="row d-inline-flex pt-2">
                            <div className="modalinputchild">
                              <div className="text-style">Customer Phone</div>
                              <input
                                className="form-control"
                                placeholder="Work Phone"
                                name="workphone"
                                type="text"
                                value={formData.workphone}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="modalinputchild">
                              <div className="text-style">Mobile</div>
                              <input
                                className="form-control"
                                placeholder="Mobile"
                                name="mobile"
                                type="text"
                                value={formData.mobile}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer className="p-2">
                        <div className="modal-bottombtns">
                          <button
                            type="button"
                            class="modalbtn-1 btn mt-0"
                            onClick={handleClose}
                          >
                            Close
                          </button>
                          <button
                            type="button"
                            class="modalbtn-3 btn btn-primary"
                            onClick={handleSaveClick}
                          >
                            Create Customer
                          </button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                  </Form.Group>
                </Col>
                <Col className="" md="3">
                  <Form.Group>
                    <label
                      className=""
                      style={{ fontSize: "14px", color: "grey" }}
                    >
                      Invoice Number <span className="valid"> *</span>
                    </label>
                    <Form.Control
                      placeholder="Invoice Number"
                      type="text"
                      name="invoiceNumber"
                      value={formData.invoiceNumber}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          invoiceNumber: e.target.value,
                        });
                        setManualCheck("Yes");
                      }}
                      style={{
                        padding: "12px",
                        backgroundColor: "#F6F6F6",
                        borderRadius: "7px",
                        color: "black",
                        height: "38px",
                      }}
                    />
                    <button
                      type="button"
                      className="btn p-0 text-left"
                      data-bs-toggle="modal"
                      data-bs-target="#generatePop"
                    >
                      <span
                        className="text-primary"
                        style={{ fontSize: "12px", fontWeight: "500" }}
                      >
                        Generate
                      </span>
                    </button>
                    <div
                      className="modal fade"
                      id="generatePop"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header d-flex align-items-center pb-2 pt-2">
                            <h5
                              className="modal-title fs-5"
                              id="generateinvoiceHead"
                            >
                              Invoice Number
                            </h5>
                            <button
                              type="button"
                              className="btn pr-0"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            >
                              <ion-icon
                                name="close-circle-outline"
                                size="large"
                                style={{ width: "28px" }}
                              ></ion-icon>
                            </button>
                          </div>
                          <div className="modal-body pt-1 pb-1">
                            <div className="popupinvoice-container ml-2 mt-2 mr-2 mb-0">
                              <div className="row headline">
                                <div className="customer-headline-label">
                                  <label className="form-label">
                                    <span className="headline">
                                      Your invoice numbers are set on
                                      auto-generate mode to save your time.
                                      <br /> Are you sure about changing this
                                      setting?
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div className="row mt-3">
                                <label className="customer-rdiobox-label d-flex align-items-center">
                                  <input
                                    className="mr-2"
                                    type="radio"
                                    name="cus_type"
                                    id="cus_bus"
                                    value="Business"
                                    onClick={setBill}
                                  />
                                  <span className="customer-option">
                                    Continue auto-generating invoice numbers
                                  </span>
                                </label>
                              </div>
                              {show1 && (
                                <div className="row ml-3 mb-3">
                                  <div className="customer-generate-inputfield">
                                    <span>Prefix</span>
                                    <input
                                      className="form-control mt-1"
                                      placeholder="Prefix"
                                      value={invoiceNumberPrefix}
                                      onChange={(e) =>
                                        setInvoiceNumberPrefix(e.target.value)
                                      }
                                    />
                                  </div>
                                  <div className="customer-generate-inputfield2">
                                    <span>Next Number</span>
                                    <input
                                      className="form-control mt-1"
                                      placeholder="Next Number"
                                      value={invoiceNumberNext}
                                      onChange={(e) =>
                                        setInvoiceNumberNext(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="row mt-1">
                                <label className="customer-rdiobox-label d-flex align-items-center">
                                  <input
                                    className="mr-2"
                                    type="radio"
                                    name="cus_type"
                                    id="cus_bus"
                                    value="Business"
                                    onClick={() => {
                                      setShow1(false);
                                    }}
                                  />
                                  <span className="customer-option">
                                    I will add them manually each time
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <div className="modal-bottombtns">
                              <button
                                type="button"
                                class="modalbtn-1 btn mt-0"
                                data-bs-dismiss="modal"
                              >
                                Close
                              </button>
                              <button
                                type="button"
                                class="modalbtn-3 btn btn-primary"
                                onClick={() => {
                                  copyAdd();
                                }}
                                data-bs-dismiss="modal"
                              >
                                Save Changes
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form.Group>
                </Col>
                <Col className="" md="3">
                  <Form.Group>
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      Order Number
                    </label>
                    <Form.Control
                      placeholder="Reference"
                      name="orderNumber"
                      value={formData.orderNumber}
                      onChange={handleInputChange}
                      type="text"
                      style={{
                        backgroundColor: "#F6F6F6",
                        borderRadius: "7px",
                        padding: "12px",
                        color: "black",
                        height: "38px",
                        "::placeholder": {
                          color: "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                        },
                      }}
                    ></Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mt-4">
                <Col md="3">
                  <Form.Group>
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      Invoice Date <span className="valid"> *</span>
                    </label>
                    <div>
                      {showInvDate ? (
                        <input
                          className="form-control"
                          type="text"
                          value={formData.invoiceDate}
                          onClick={(e, date) => {
                            setShowInvDate(false);
                            setFormData({
                              ...formData,
                              invoiceDate: normalDateFormat(startDate),
                            });
                            handleDate(startDate);
                            setShowDuePerTerm(true);
                          }}
                          readOnly
                          style={{
                            backgroundColor: "#F6F6F6",
                            borderRadius: "7px",
                            padding: "12px",
                            height: "38px",
                            width: "260.8px",
                          }}
                        />
                      ) : (
                        <div className="customDatePickerWidth">
                          <DatePicker
                            className="form-control"
                            selected={startDate}
                            dateFormat="dd-MM-yyyy"
                            onChange={(date) => handleDate(date)}
                            showIcon
                            toggleCalendarOnIconClick
                          />
                        </div>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col className="" md="3">
                  <Form.Group>
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      Payment Terms
                    </label>
                    <Select
                      // className="dropdown-field"
                      options={optionPaymentTerms}
                      value={optionPaymentTerms.find(
                        (option) => option.value === fetchedPaymentTerms
                      )}
                      onChange={handlePaymentChange}
                      placeholder="Select Terms"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: "#F6F6F6",
                          borderRadius: "7px",
                          height: "46px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          height: "19px",
                        }),
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col className="" md="3">
                  <Form.Group>
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      Due Date <span className="valid"> *</span>
                    </label>
                    <div>
                      {showDueDate ? (
                        <input
                          className="form-control"
                          type="text"
                          value={dueDate || formData.dueDate}
                          onClick={(e) => {
                            setShowDueDate(false);
                            setSelectedTerms("Custom");
                            setFormData({ ...formData, terms: "Custom" });
                            setFetchedPaymentTerms("Custom");
                          }}
                          style={{
                            backgroundColor: "#F6F6F6",
                            borderRadius: "7px",
                            padding: "12px",
                            height: "38px",
                            width: "260.8px",
                          }}
                          readOnly
                          showIcon
                          toggleCalendarOnIconClick
                        />
                      ) : (
                        <div className="customDatePickerWidth">
                          <DatePicker
                            className="form-control"
                            selected={startDate1}
                            dateFormat="dd-MM-yyyy"
                            showIcon
                            toggleCalendarOnIconClick
                            onChange={(date) => handleDate1(date)}
                          />
                        </div>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col md="3">
                  <Form.Group>
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      Sales Person
                    </label>
                    <Select
                      value={optionSales.find(
                        (option) => option.value === fetchedSalesPerson
                      )}
                      options={optionSales}
                      onChange={(selectedOption) =>
                        handleSalesPersonChange(
                          selectedOption.label,
                          selectedOption.value
                        )
                      }
                      placeholder="Select a SalesPerson"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: "#F6F6F6",
                          borderRadius: "7px",
                          height: "46px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          height: "19px",
                        }),
                      }}
                    />
                    <button
                      type="button"
                      class="btn p-0 text-left"
                      onClick={handleSalesShow}
                    >
                      <span
                        class="text-primary"
                        style={{ fontSize: "12px", fontWeight: "500" }}
                      >
                        New Sales Person
                      </span>
                    </button>
                    <Modal show={showSalesModal} onHide={handleSalesClose}>
                      <div class="modal-header d-flex align-items-center pb-2 pt-2">
                        <h5 class="modal-title fs-5" id="salespersonHead">
                          Add Sales Person
                        </h5>
                        <button
                          type="button"
                          className="btn pr-0"
                          onClick={handleSalesClose}
                        >
                          <ion-icon
                            name="close-circle-outline"
                            size="large"
                            style={{ width: "28px" }}
                          ></ion-icon>
                        </button>
                      </div>
                      <Modal.Body>
                        {validationMessage2 && (
                          <Alert severity="error" className="mt-0">
                            {validationMessage2
                              .split("\n")
                              .map((message, index) => (
                                <div key={index}>{message}</div>
                              ))}
                          </Alert>
                        )}{" "}
                        <div className="row pt-2">
                          <div className="modalsalesinput">
                            <label className="form-label">
                              <span style={{ color: "red" }}>Name *</span>
                            </label>
                            <input
                              className="form-control"
                              placeholder="Add Full Name"
                              id="name"
                              name="name"
                              type="text"
                              value={salesData.name}
                              onChange={handleSalesInputChange}
                            />
                          </div>
                        </div>
                        <div className="row pt-4">
                          <div className="modalsalesinput">
                            <label className="form-label">
                              <span>Email </span>
                            </label>
                            <input
                              className="form-control"
                              placeholder="Add Email Address"
                              id="email"
                              name="email"
                              type="text"
                              value={salesData.email}
                              onChange={handleSalesInputChange}
                            />
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer className="p-2">
                        <div className="modal-bottombtns">
                          <button
                            type="button"
                            class="modalbtn-1 btn mt-0"
                            onClick={handleSalesClose}
                          >
                            Close
                          </button>
                          <button
                            type="button"
                            class="modalbtn-3 btn btn-primary"
                            onClick={handleSalesPerson}
                            data-bs-dismiss="modal"
                          >
                            Create Sales Person
                          </button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                  </Form.Group>
                </Col>
                <Col className="" md="6">
                  <Form.Group>
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      Subject
                    </label>
                    <Form.Control
                      placeholder="Let your customer know what this invoice is for "
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      type="text"
                      style={{
                        backgroundColor: "#F6F6F6",
                        borderRadius: "7px",
                        padding: "12px",
                        color: "black",
                        height: "40px",
                        "::placeholder": {
                          color: "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                        },
                      }}
                    ></Form.Control>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md="3">
                  <Form.Group>
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      Tracking No.
                    </label>
                    <Form.Control
                      placeholder="Tracking No."
                      name="batchNo"
                      value={formData.batchNo}
                      readOnly
                      type="text"
                      style={{
                        backgroundColor: "#F6F6F6",
                        borderRadius: "7px",
                        padding: "12px",
                        color: "black",
                        height: "38px",
                        "::placeholder": {
                          color: "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                        },
                      }}
                    ></Form.Control>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className="mt-3" md="3">
                  <Form.Group>
                    <label
                      className="text-primary"
                      style={{ fontSize: 14, fontWeight: "600" }}
                    >
                      ITEM INFO
                    </label>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Card>
                    <div style={{ overflowX: "auto" }}>
                      <table
                        className="table table-bordered mb-0"
                        style={{
                          width: "100%",
                        }}
                      >
                        <thead className="text-center">
                          <tr>
                            <th
                              style={{
                                whiteSpace: "nowrap",
                                minWidth: "350px",
                              }}
                            >
                              {" "}
                              ITEM DETAILS
                            </th>
                            {batchIdCheck === "YES" && (
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                BATCH ID
                              </th>
                            )}
                             <th
                              style={{
                                whiteSpace: "nowrap",
                                minWidth: "100px",
                              }}
                            >
                              ITEM CODE
                            </th>
                            {hsnCheck === "YES" && (
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                HSN/SAC
                              </th>
                            )}
                            {sizeCheck === "YES" && (
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                SIZE
                              </th>
                            )}
                             <th
                              style={{
                                whiteSpace: "nowrap",
                                minWidth: "180px",
                              }}
                            >
                              {" "}
                              PER
                            </th>
                            {quantityCheck === "YES" && (
                            <th
                              style={{
                                whiteSpace: "nowrap",
                                minWidth: "180px",
                              }}
                            >
                              {" "}
                              QUANTITY
                            </th>
                            )}
                            {netRateCheck === "YES" && (
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                RATE
                              </th>
                            )}
                            <th
                              style={{
                                whiteSpace: "nowrap",
                                minWidth: "100px",
                              }}
                            >
                              {" "}
                              {netRateCheck === "YES" ? "NET RATE" : "RATE"}
                            </th>
                            {packCheck === "YES" && (
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                PACK
                              </th>
                            )}
                            {discountCheck === "YES" && (
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                DISCOUNT
                              </th>
                            )}{" "}
                            {bussinessRegistered === "YES" && (
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                TAX
                              </th>
                            )}
                            <th
                              style={{
                                whiteSpace: "nowrap",
                                minWidth: "50px",
                              }}
                            >
                              {" "}
                              AMOUNT
                            </th>
                            <th
                              style={{
                                whiteSpace: "nowrap",
                                minWidth: "50px",
                              }}
                            >
                              {" "}
                              ACTION
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {userDetails.map((data, i) => {
                            const amount = calculateAmount(data, data.tax);
                            const taxinAmount = calculateTAX(data);
                                const totalAmountWithTax = parseFloat(amount) + parseFloat(taxinAmount);
                            const itemDescription = itemDescriptions.find(
                              (desc) => desc.itemDetails === data.itemDetails
                            );
                            return (
                              <tr key={i}>
                                <td style={{ whiteSpace: "nowrap" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <input
                                      className="form-control noBorder"
                                      placeholder="Search items..."
                                      value={data.itemDetails}
                                      onChange={(e) =>
                                        handleItemDetailsChange(e, i)
                                      }
                                      style={{ flex: 1 }}
                                    />
                                    {data.itemDetails && (
                                      <button
                                        type="button"
                                        className="btn p-0"
                                        onClick={() =>
                                          handleItemShow(data.itemDetails)
                                        }
                                        style={{ marginLeft: "10px" }}
                                      >
                                        <span
                                          className="text-primary"
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "500",
                                          }}
                                        >
                                          Edit
                                        </span>
                                      </button>
                                    )}
                                  </div>
                                  {itemDescription && (
                                    <div
                                      style={{
                                        marginTop: "10px",
                                        color: "#6c757d",
                                        whiteSpace: "pre-line",
                                      }}
                                    >
                                      {itemDescription.description}
                                    </div>
                                  )}

                                  {searchPerformed &&
                                    data.itemDetails &&
                                    i === searchIndex && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          zIndex: 9999, // Higher than scrollbar
                                          top: "100%", // Position below input
                                          left: 0,
                                          width: "60%",
                                        }}
                                      >
                                        {searchResults.length === 0 && ""}
                                        {searchResults.length > 0 && (
                                          <ul
                                            style={{
                                              listStyleType: "none",
                                              padding: 0,
                                              position: "absolute",
                                              top: "calc(100% + 10px)",
                                              left: 0,
                                              zIndex: 1000,
                                              backgroundColor: "#FFF",
                                              boxShadow:
                                                "0px 0px 10px rgba(0, 0, 0, 0.2)",
                                              borderRadius: "5px",
                                              width: "100%",
                                              maxHeight: "200px", // Set a max height for the list
                                              overflowY: "auto", // Enable vertical scrolling
                                            }}
                                          >
                                            {searchResults.map(
                                              (result, index) => (
                                                <li
                                                  key={index}
                                                  onClick={() =>
                                                    handleItemSelect(
                                                      result.name,
                                                      result.id,
                                                      i
                                                    )
                                                  }
                                                  onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor =
                                                      "#408dfb";
                                                    e.target.style.color =
                                                      "#FFF";
                                                    e.target.style.borderRadius =
                                                      "5px"; // Apply border radius on hover
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor =
                                                      "";
                                                    e.target.style.color =
                                                      "#000";
                                                    e.target.style.borderRadius =
                                                      ""; // Reset border radius
                                                  }}
                                                  style={{
                                                    padding: "12px",
                                                    cursor: "pointer",
                                                    whiteSpace: "nowrap", // Prevent text from overflowing
                                                    overflow: "hidden", // Hide overflow text
                                                    textOverflow: "ellipsis", // Add ellipsis for overflowing text
                                                  }}
                                                >
                                                 <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      marginBottom: "4px",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      {result.name}
                                                    </span>
                                                    <span>
                                                      Code:{" "}
                                                      {result.itemCode || "N/A"}
                                                    </span>
                                                  </div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    <span>
                                                      Make:{" "}
                                                      {result.make || "N/A"}
                                                    </span>
                                                    <span>
                                                      Stock:{" "}
                                                      {result.openingStock ||
                                                        "N/A"}
                                                    </span>
                                                  </div>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        )}
                                      </div>
                                    )}
                                </td>

                                <Modal
                                  show={showItemModal}
                                  onHide={handleItemClose}
                                >
                                  <div class="modal-header d-flex align-items-center pb-2 pt-2">
                                    <h5
                                      class="modal-title fs-5"
                                      id="salespersonHead"
                                    >
                                      Add Item Description
                                    </h5>
                                    <button
                                      type="button"
                                      className="btn pr-0"
                                      onClick={handleItemClose}
                                    >
                                      <ion-icon
                                        name="close-circle-outline"
                                        size="large"
                                        style={{ width: "28px" }}
                                      ></ion-icon>
                                    </button>
                                  </div>
                                  <Modal.Body>
                                    <Row>
                                      <Col md="12">
                                        <div className="row pt-2">
                                          <div className="col-lg-6">
                                            <label
                                              className="form-label"
                                              style={{
                                                fontSize: "14px",
                                                color: "grey",
                                                borderRadius: "7px",
                                              }}
                                            >
                                              Item
                                            </label>
                                          </div>
                                        </div>
                                        <div className="col-lg-12 pl-0 pr-0">
                                          <input
                                            className="form-control"
                                            placeholder="Name"
                                            id="name"
                                            name="name"
                                            type="text"
                                            value={itemName}
                                            readOnly
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col md="12">
                                        <div className="row pt-2">
                                          <div className="col-lg-6">
                                            <label
                                              className="form-label"
                                              style={{
                                                fontSize: "14px",
                                                color: "grey",
                                                borderRadius: "7px",
                                              }}
                                            >
                                              Description
                                            </label>
                                          </div>
                                        </div>
                                        <div className="col-lg-12 pl-0 pr-0">
                                          <textarea
                                            className="cn-textarea"
                                            type="text"
                                            placeholder="Item Description"
                                            name="description"
                                            value={itemData.description}
                                            onChange={handleItemChange}
                                            rows={2}
                                            style={{
                                              backgroundColor: "#F6F6F6",
                                              borderRadius: "9px",
                                              padding: "12px",
                                              width: "100%",
                                            }}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </Modal.Body>
                                  <Modal.Footer className="p-2">
                                    <div className="modal-bottombtns">
                                      <button
                                        type="button"
                                        class="modalbtn-1 btn mt-0"
                                        onClick={handleItemClose}
                                      >
                                        Close
                                      </button>
                                      <button
                                        type="button"
                                        class="modalbtn-3 btn btn-primary"
                                        onClick={handleItem}
                                        data-bs-dismiss="modal"
                                      >
                                        Add Description
                                      </button>
                                    </div>
                                  </Modal.Footer>
                                </Modal>
                                {batchIdCheck === "YES" && (
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <input
                                      className="form-control noArrowNumber noBorder bg-white"
                                      value={data.batchId || ""}
                                      type="number"
                                      name="batchId"
                                      onChange={(e) =>
                                        handleInputChangess(e, i)
                                      }
                                    />
                                  </td>
                                )}
                               <td style={{ whiteSpace: "nowrap" }}>
                                  <div style={{ position: "relative" }}>
                                    <input
                                      className="form-control noArrowNumber noBorder"
                                      value={data.itemCode || ""}
                                      name="itemCode"
                                      type="text"
                                      placeholder="Item Code"
                                      onChange={(e) =>
                                        handleItemCodeChange(e, i)
                                      }
                                      style={{ flex: 1 }}
                                    />
                                  </div>
                                  {searchPerformedItemCode &&
                                    data.itemCode &&
                                    i === searchIndexItemCode && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          zIndex: 9999,
                                          top: "100%",
                                          left: 0,
                                          width: "60%", // Increased width
                                        }}
                                      >
                                        {searchResultsItemCode.length > 0 && (
                                          <ul
                                            style={{
                                              listStyleType: "none",
                                              padding: 0,
                                              position: "absolute",
                                              top: "calc(100% + 10px)",
                                              left: 0,
                                              zIndex: 1000,
                                              backgroundColor: "#FFF",
                                              boxShadow:
                                                "0px 0px 10px rgba(0, 0, 0, 0.2)",
                                              borderRadius: "5px",
                                              width: "100%",
                                              maxHeight: "300px",
                                              overflowY: "auto",
                                            }}
                                          >
                                            {searchResultsItemCode.map(
                                              (result, index) => (
                                                <li
                                                  key={index}
                                                  onClick={() =>
                                                    handleItemCodeSelect(
                                                      result.itemCode,
                                                      result.id,
                                                      i
                                                    )
                                                  }
                                                  onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor =
                                                      "#408dfb";
                                                    e.target.style.color =
                                                      "#FFF";
                                                    e.target.style.borderRadius =
                                                      "5px";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor =
                                                      "";
                                                    e.target.style.color =
                                                      "#000";
                                                    e.target.style.borderRadius =
                                                      "";
                                                  }}
                                                  style={{
                                                    padding: "12px",
                                                    cursor: "pointer",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      marginBottom: "4px",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      {result.name}
                                                    </span>
                                                    <span>
                                                      Code:{" "}
                                                      {result.itemCode || "N/A"}
                                                    </span>
                                                  </div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    <span>
                                                      Make:{" "}
                                                      {result.make || "N/A"}
                                                    </span>
                                                    <span>
                                                      Stock:{" "}
                                                      {result.openingStock ||
                                                        "N/A"}
                                                    </span>
                                                  </div>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        )}
                                      </div>
                                    )}
                                </td>
                                {hsnCheck === "YES" && (
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <input
                                      className="form-control noArrowNumber noBorder bg-white"
                                      value={data.hsnSac || ""}
                                      type="number"
                                      name="hsnSac"
                                      onChange={(e) =>
                                        handleInputChangess(e, i)
                                      }
                                    />
                                  </td>
                                )}
                                {sizeCheck === "YES" && (
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <input
                                      className="form-control noArrowNumber noBorder"
                                      value={data.size || ""}
                                      type="number"
                                      name="size"
                                      onChange={(e) =>
                                        handleInputChangess(e, i)
                                      }
                                    />
                                  </td>
                                )}
                                <td style={{ whiteSpace: "nowrap" }}>
                                  <div className="d-flex">
                                    <input
                                      className="form-control noArrowNumber noBorder"
                                      value={data.per || ""}
                                      type="number"
                                      name="per"
                                      readOnly
                                      style={{ backgroundColor: "white" }}
                                      // onChange={(e) =>
                                      //   handleQuantityChange(e, i)
                                      // }
                                    />
                                    {data.alternateUnit &&
                                      data.alternateUnitValue && (
                                        <input
                                          className="form-control px-1"
                                          style={{}}
                                          value={`${data.singleAltUnitValue} ${data.alternateUnit}`}
                                          type="text"
                                          readOnly
                                        />
                                      )}
                                  </div>
                                </td>
                                {quantityCheck === "YES" && (
                                <td style={{ whiteSpace: "nowrap" }}>
                                  <div className="d-flex">
                                    <input
                                      className="form-control noArrowNumber noBorder"
                                      value={data.quantity || ""}
                                      type="number"
                                      name="quantity"
                                      onChange={(e) =>
                                        handleInputChangess(e, i)
                                      }
                                    />
                                    {(data.hasAlternateUnit ||
                                      data.alternateUnit) && (
                                      <input
                                        className="form-control px-1"
                                        name="alternateUnitValue"
                                        style={{}}
                                        value={`${
                                          data.calculatedAltUnitValue
                                        } ${data.alternateUnit || ""}`}
                                        type="text"
                                        readOnly
                                      />
                                    )}
                                  </div>
                                </td>
                                )}
                                {netRateCheck === "YES" && (
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <input
                                      className="form-control noArrowNumber noBorder"
                                      name="rateOne"
                                      value={data.rateOne}
                                      type="number"
                                      onChange={(e) =>
                                        handleInputChangess(e, i)
                                      }
                                    />
                                  </td>
                                )}
                                <td style={{ whiteSpace: "nowrap" }}>
                                  <input
                                    className="form-control noArrowNumber noBorder"
                                    value={data.rate}
                                    name="rate"
                                    type="number"
                                    onChange={(e) => handleInputChangess(e, i)}
                                  />
                                </td>
                                {packCheck === "YES" && (
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <input
                                      className="form-control noArrowNumber noBorder"
                                      value={data.pack}
                                      name="pack"
                                      type=""
                                      onChange={(e) =>
                                        handleInputChangess(e, i)
                                      }
                                    />
                                  </td>
                                )}

                                {discountCheck === "YES" && (
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <div className="d-flex justify-content-center">
                                      <input
                                        className="form-control col-md-6 noBorder"
                                        name="discount"
                                        value={data.discount || ""}
                                        type="number"
                                        onChange={(e) =>
                                          handleInputChangess(e, i)
                                        }
                                        style={{
                                          textAlign: "center",
                                          padding: "0px",
                                          marginRight: "5px",
                                        }}
                                      />
                                      <select
                                        className="border-0 noBorder"
                                        value={data.discountType}
                                        onChange={(e) =>
                                          handleInputChangess(e, i)
                                        }
                                        name="discountType"
                                        style={{
                                          textAlign: "center",
                                          padding: "0px",
                                          marginRight: "5px",
                                        }}
                                      >
                                        <option value="₹">₹</option>
                                        <option value="%">%</option>
                                      </select>
                                    </div>
                                  </td>
                                )}

                                {bussinessRegistered === "YES" && (
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <select
                                      className="form-control"
                                      value={data.tax}
                                      onChange={(e) => handleTaxChange(e, i)}
                                    >
                                      <option value="0">N/A</option>
                                      <option value="0">0 GST [0%]</option>
                                      <option value="5">5 GST [5%]</option>
                                      <option value="12">12 GST [12%]</option>
                                      <option value="18">18 GST [18%]</option>
                                      <option value="28">28 GST [28%]</option>
                                    </select>
                                  </td>
                                )}
                                <td style={{ whiteSpace: "nowrap" }}>
                                  <span>
                                    {parseFloat(totalAmountWithTax).toFixed(2)}
                                  </span>
                                </td>
                                <td style={{ whiteSpace: "nowrap" }}>
                                  <button
                                    type="button"
                                    className="btn px-2 btn-light icon-border btn-sm"
                                    onClick={() => handleDeleteRow(i, data.id)}
                                  >
                                    <i className="fa fa-trash text-danger"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col>
                  <button
                    className="btn addline-btn"
                    type="button"
                    onClick={handleAdd}
                  >
                    + Add New Row
                  </button>
                </Col>
              </Row>

              {/* endtable */}

              <div className="customer-grid-container">
                <div className="customer-flex-item pb-0 pl-0 d-flex flex-column-reverse">
                  <div className="row pt-3">
                    <div className="col-lg-6">
                      <label
                        className="form-label"
                        style={{ fontSize: "14px", color: "grey" }}
                      >
                        Customer Notes
                      </label>
                    </div>

                    <div className="col-lg-12">
                      <textarea
                        className="form-control cnotes-textarea"
                        placeholder="Customer Notes..."
                        name="customerNote"
                        value={
                          formData.customerNote || "Thank You For Business."
                        }
                        onChange={handleInputChange}
                        type="text"
                        rows={1}
                        style={{
                          backgroundColor: "#F6F6F6",
                          borderRadius: "9px",
                          padding: "12px",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="customer-subtotal-box pb-0">
                  <div className="customer-flex-item">
                    <div className="row">
                      <div className="col-lg-8">
                        <label className="form-label">Sub Total</label>
                      </div>
                      <div className="col-lg-4 text-end pl-0">
                        <label className="form-label">
                          {calculateSubTotal()}
                        </label>
                      </div>
                    </div>

                    {discountCheck === "YES" && (
                      <div className="row d-flex align-items-baseline mt-1">
                        <div className="col-lg-5 pr-0">
                          <label>Discount</label>
                        </div>
                        <div className="col-lg-3 pl-0 d-flex">
                          <input
                            className="form-control"
                            value={disAllValue || "0"}
                            type="number"
                            name="discount"
                            onChange={handleDisAllValueChange}
                            style={{
                              height: "36px",
                              padding: "3px 8px",
                              backgroundColor: "#F6F6F6",
                            }}
                          />
                          <select
                            className="form-control ml-1 pl-0 rounded"
                            name="discountType"
                            value={discountType}
                            onChange={handleDiscountTypeChange}
                            style={{
                              height: "36px",
                              width: "50px",
                              padding: "3px 8px",
                              backgroundColor: "#F6F6F6",
                            }}
                          >
                            <option disabled>Select</option>
                            <option value="₹">₹</option>
                            <option value="%">%</option>
                          </select>
                        </div>
                        <div className="col-lg-4 text-end pl-0">
                          <label className="form-label textColor-red">
                            {isNaN(parseFloat(disValue).toFixed(2))
                              ? "0.00"
                              : -parseFloat(disValue).toFixed(2)}
                          </label>
                        </div>
                      </div>
                    )}

                    {bussinessRegistered === "YES" && (
                      <div className="row mt-2">
                        {/* {userState.toString() !==
                          customerState.toString() && (
                            <>
                              <div className="col-lg-8">
                                <label className="form-label required">
                                  IGST
                                </label>
                              </div>
                              <div className="col-lg-4 text-end pl-0">
                                <label className="form-label required">
                                  {calculateIGST()}
                                </label>
                              </div>
                            </>
                          )} */}

                        {/* {userState.toString() !== customerState.toString() && (
                          <>
                            {calculateIGSTForTax().map((taxResult, index) => (
                              <React.Fragment key={index}>
                                <div className="col-lg-8">
                                  <label className="form-label required">IGST ({(taxResult.taxRate * 100).toFixed(0)}%)</label>
                                </div>
                                <div className="col-lg-4 text-end pl-0">
                                  <label className="form-label required">
                                    {taxResult.totalIGST.toFixed(2)}
                                  </label>
                                </div>
                              </React.Fragment>
                            ))}
                          </>
                        )} */}

                        {/* {userState.toString() === customerState.toString() && (
                          <>
                            <div className="col-lg-8">
                              <label className="form-label required">CGST</label>
                            </div>
                            <div className="col-lg-4 text-end pl-0">
                              <label className="form-label">{calculateSGSTandCGST().totalCGST || formData.cgst}</label>
                            </div>
                          </>
                        )}

                        {userState.toString() === customerState.toString() && (
                          <>
                            <div className="col-lg-8 mt-2">
                              <label className="form-label required">SGST</label>
                            </div>
                            <div className="col-lg-4 text-end pl-0 mt-2">
                              <label className="form-label">{calculateSGSTandCGST().totalSGST}</label>
                            </div>
                          </>
                        )} */}

                        {/* {userState.toString() === customerState.toString() && (
                          <>
                            {Object.entries(calculateGroupedSGSTandCGST(userDetails)).map(([taxRate, taxData], index) => (
                              <React.Fragment key={index}>
                                <div className="col-lg-8">
                                  <label className="form-label required">CGST ({(parseFloat(taxRate) * 100).toFixed(0)}%)</label>
                                </div>
                                <div className="col-lg-4 text-end pl-0">
                                  <label className="form-label required">{taxData.totalCGST.toFixed(2)}</label>
                                </div>
                                <div className="col-lg-8 mt-2">
                                  <label className="form-label required">SGST ({(parseFloat(taxRate) * 100).toFixed(0)}%)</label>
                                </div>
                                <div className="col-lg-4 text-end pl-0 mt-2">
                                  <label className="form-label required">{taxData.totalSGST.toFixed(2)}</label>
                                </div>
                              </React.Fragment>
                            ))}
                          </>
                        )} */}

                        {/* {userState.toString() === customerState.toString() ? (
                          <>
                            {Object.entries(calculateGroupedSGSTandCGST(userDetails)).map(([taxRate, taxData], index) => (
                              <React.Fragment key={index}>
                                <div className="col-lg-8">
                                  <label className="form-label required">CGST ({(parseFloat(taxRate) * 100).toFixed(0)}%)</label>
                                </div>
                                <div className="col-lg-4 text-end pl-0">
                                  <label className="form-label required">{taxData.totalCGST.toFixed(2)}</label>
                                </div>
                                <div className="col-lg-8 mt-2">
                                  <label className="form-label required">SGST ({(parseFloat(taxRate) * 100).toFixed(0)}%)</label>
                                </div>
                                <div className="col-lg-4 text-end pl-0 mt-2">
                                  <label className="form-label required">{taxData.totalSGST.toFixed(2)}</label>
                                </div>
                              </React.Fragment>
                            ))}
                          </>
                        ) : (
                          <>
                            {calculateIGSTForTax().map((taxResult, index) => (
                              <React.Fragment key={index}>
                                <div className="col-lg-8">
                                  <label className="form-label required">IGST ({(taxResult.taxRate * 100).toFixed(0)}%)</label>
                                </div>
                                <div className="col-lg-4 text-end pl-0">
                                  <label className="form-label required">{taxResult.totalIGST.toFixed(2)}</label>
                                </div>
                              </React.Fragment>
                            ))}
                          </>
                        )} */}

                        {userState.state !== customerState && (
                          <>
                            {calculateIGSTForTax().map((taxResult, index) => (
                              <React.Fragment key={index}>
                                <div className="col-lg-8">
                                  <label className="form-label required">
                                    IGST ({(taxResult.taxRate * 100).toFixed(0)}
                                    %)
                                  </label>
                                </div>
                                <div className="col-lg-4 text-end pl-0">
                                  <label className="form-label required">
                                    {taxResult.totalIGST.toFixed(2)}
                                  </label>
                                </div>
                              </React.Fragment>
                            ))}
                          </>
                        )}

                        {userState.state === customerState && (
                          <>
                            {Object.entries(calculateGroupedSGSTandCGST()).map(
                              ([taxRate, taxData], index) => (
                                <React.Fragment key={index}>
                                  <div className="col-lg-8">
                                    <label className="form-label required">
                                      CGST (
                                      {((parseFloat(taxRate) * 100) / 2)
                                        .toFixed(1)
                                        .replace(/\.0+$/, "")}
                                      %)
                                    </label>
                                  </div>
                                  <div className="col-lg-4 text-end pl-0">
                                    <label className="form-label required">
                                      {taxData.totalCGST.toFixed(2)}
                                    </label>
                                  </div>
                                  <div className="col-lg-8 mt-2">
                                    <label className="form-label required">
                                      SGST (
                                      {((parseFloat(taxRate) * 100) / 2)
                                        .toFixed(1)
                                        .replace(/\.0+$/, "")}
                                      %)
                                    </label>
                                  </div>
                                  <div className="col-lg-4 text-end pl-0 mt-2">
                                    <label className="form-label required">
                                      {taxData.totalSGST.toFixed(2)}
                                    </label>
                                  </div>
                                </React.Fragment>
                              )
                            )}
                          </>
                        )}
                      </div>
                    )}
                    <div className="row mt-3 mb-3">
                      <div className="col-lg-5 pr-0">
                        <input
                          className="form-control col-md-10"
                          type="text"
                          placeholder="Adjustment Label" // Provide a placeholder for user input
                          value={formData.adjustmentLabel}
                          onChange={handleInputChange}
                          name="adjustmentLabel"
                          style={{
                            backgroundColor: "#F6F6F6",
                            borderRadius: "10px",
                            color: "black",
                            "::placeholder": {
                              color:
                                "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                            },
                          }}
                        />
                      </div>
                      <div className="col-lg-5 pl-0">
                        <input
                          className="form-control col-md-10"
                          type="text"
                          placeholder="Value"
                          name="adjustment"
                          value={formData.adjustment}
                          onChange={handleInputChange}
                          style={{
                            backgroundColor: "#F6F6F6",
                            borderRadius: "10px",
                            color: "black",
                            "::placeholder": {
                              color:
                                "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                            },
                          }}
                        />
                      </div>
                      <div className="col-lg-2 text-end pl-0">
                        <label className="form-label mt-2">
                          {oppositeValue || formData.adjustment}
                        </label>
                      </div>
                    </div>

                    {/* <div className="my-4 d-flex justify-content-between">
                      <div className="d-flex justify-content-between" style={{ width: "70%" }}>
                        <div className="col-lg-7 pl-0">
                          <label className="rdiobox">
                            <input className="mx-1" type="radio" name="cus_type" id="cus_bus" value="TDS" checked={formData.type === "TDS"} onClick={() => handleRadioClick("TDS")} />
                            <span>TDS</span>
                          </label>
                          <label className="rdiobox ml-3">
                            <input className="mx-1" type="radio" name="cus_type" id="cus_indivi" value="TCS" checked={formData.type === "TCS"} onClick={() => handleRadioClick("TCS")} />
                            <span>TCS</span>
                          </label>
                        </div>
                        <div className="col-lg-6 p-0" style={{ width: "190px" }}>
                          {(showing1 || formData.type === "TDS") && <Select options={tds} value={selectedTdsOption} onChange={handleTdsOptionChange} placeholder="Select TDS..." styles={customStyles3} />}

                          {(showing2 || formData.type === "TCS") && <Select options={tcs} value={selectedTcsOption} onChange={handleTcsOptionChange} placeholder="Select TCS..." styles={customStyles3} />}
                        </div>
                      </div>
                      {(showing1 || formData.type === "TDS") && <label className="form-label">{discountAmountTds}</label>}

                      {(showing2 || formData.type === "TCS") && <label className="form-label">{discountAmountTcs}</label>}
                    </div> */}

                    <div className="my-4 d-flex justify-content-between">
                      <div
                        className="d-flex justify-content-between"
                        style={{ width: "70%" }}
                      >
                        <div className="col-lg-7 pl-0">
                          <label className="rdiobox">
                            <input
                              className="mx-1"
                              type="radio"
                              name="cus_type"
                              id="cus_bus"
                              value="TDS"
                              checked={formData.type === "TDS"}
                              onChange={() => handleRadioClick("TDS")}
                            />
                            <span>TDS</span>
                          </label>
                          <label className="rdiobox ml-3">
                            <input
                              className="mx-1"
                              type="radio"
                              name="cus_type"
                              id="cus_indivi"
                              value="TCS"
                              checked={formData.type === "TCS"}
                              onChange={() => handleRadioClick("TCS")}
                            />
                            <span>TCS</span>
                          </label>
                        </div>
                        <div
                          className="col-lg-6 p-0"
                          style={{ width: "190px" }}
                        >
                          {(showing1 || formData.type === "TDS") && (
                            <Select
                              options={tds}
                              value={selectedTdsOption}
                              onChange={handleTdsOptionChange}
                              placeholder="Select TDS..."
                              styles={customStyles3}
                            />
                          )}

                          {(showing2 || formData.type === "TCS") && (
                            <Select
                              options={tcs}
                              value={selectedTcsOption}
                              onChange={handleTcsOptionChange}
                              placeholder="Select TCS..."
                              styles={customStyles3}
                            />
                          )}
                        </div>
                      </div>
                      {(showing1 || formData.type === "TDS") && (
                        <label className="form-label">
                          {discountAmountTds}
                        </label>
                      )}

                      {(showing2 || formData.type === "TCS") && (
                        <label className="form-label">
                          {discountAmountTcs}
                        </label>
                      )}
                    </div>

                    <hr />
                    <div className="my-3 d-flex justify-content-between">
                      <label className="form-label required ">
                        Total (in Rupees) :
                      </label>
                      <label className="form-label required">{total}</label>
                    </div>
                  </div>
                </div>
              </div>
              <hr className="mt-4" />
              <Row>
                <Col md="12">
                  <div className="row pt-2">
                    <div className="col-lg-6">
                      <label
                        className="form-label"
                        style={{
                          fontSize: "14px",
                          color: "grey",
                          borderRadius: "7px",
                        }}
                      >
                        Terms & Conditions
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-12 pl-0 pr-0">
                    {/* <Editor
                      value={content}
                      apiKey="4h8oo2lv4rl9gi28mb7hv90bwsf4k369lnf0gmxragfpofwj"
                      init={{
                        branding: false,
                        height: 500,
                        menubar: true,
                        plugins:
                          "print preview paste searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern",
                        toolbar:
                          "formatselect | bold italic underline strikethrough | forecolor backcolor blockquote | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat",
                        image_advtab: true,
                      }}
                      onEditorChange={handleEditorChange}
                    /> */}
                    <ReactQuill
                      value={content}
                      onChange={handleEditorChange} // Function to update state
                      theme="snow" // Use "bubble" for a minimal UI
                      style={{ height: "300px", marginBottom: "50px" }}
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, 3, 4, 5, 6, false] }], // Headers
                          [{ font: [] }], // Font options
                          [{ size: [] }], // Font size
                          [{ color: [] }, { background: [] }], // Text color & background
                          ["bold", "italic", "underline", "strike"], // Basic text styles
                          [{ script: "sub" }, { script: "super" }], // Subscript & superscript
                          [{ align: [] }], // Text alignment
                          [{ list: "ordered" }, { list: "bullet" }], // Lists
                          [{ indent: "-1" }, { indent: "+1" }], // Indentation
                          ["blockquote", "code-block"], // Blockquote & code block
                          ["link", "image", "video"], // Media links
                          ["clean"], // Remove formatting
                        ],
                      }}
                      formats={[
                        "header",
                        "font",
                        "size",
                        "color",
                        "background",
                        "bold",
                        "italic",
                        "underline",
                        "strike",
                        "script",
                        "align",
                        "list",
                        "bullet",
                        "indent",
                        "blockquote",
                        "code-block",
                        "link",
                        "image",
                        "video",
                      ]}
                    />
                    <i className="text-muted">
                      This Terms and Condition will be displayed on the invoice
                    </i>
                  </div>
                </Col>
              </Row>

              <div className="text-right invoice-bottombtns">
                <button
                  type="button"
                  className="btn-1 btn mt-0"
                  disabled={loading}
                  onClick={handleCancleClick}
                >
                  Cancel
                </button>
                {props.fetchedStatus === "Draft" && (
                  <button
                    type="button"
                    className="btn-1 btn mt-0"
                    onClick={insertDataIntoDatabaseAsDraft}
                  >
                    {isLoading2 ? "Saving..." : "Save as Draft"}
                  </button>
                )}
                <button
                  type="button"
                  className="btn-3 btn btn-primary"
                  onClick={insertDataIntoDatabase}
                >
                  {isLoading ? "Updating..." : "Update"}
                </button>
              </div>
              <div className="clearfix"></div>
            </Form>
            {/* </Card.Body> */}
          </Card>
        </Col>
      </Row>
    </div>
  );
}
export default InvoiceUpdate;
